/**
 * Aanvullende Zuid-Hollandse woonplaatsen (officiële BAG-woonplaatsen).
 * Automatisch samengesteld uit PDOK/BAG-locatiedata, OpenStreetMap-POI's en
 * de straatnamenregistratie; iedere plaats krijgt eigen intro, bezienswaardig-
 * heden, straten en weetjes zodat er geen duplicate content ontstaat.
 */

import type { LocalPlace } from "./local-seo";

export const ZH_PLACES: LocalPlace[] = [
  {
    slug: "s-gravendeel",
    name: "'s-Gravendeel",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7706,
    lng: 4.6054,
    intro:
      "Voor bewoners en bezoekers van 's-Gravendeel is de taxi vaak de snelste verbinding met Schiphol (90 km) en Den Haag (58 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Historische Vereniging 's-Gravendeel (museum)", "Het Vliegend Hert (molen)", "Middelvliet (natuurgebied)", "Nieuwlandse- en Mijlbos (natuurgebied)"],
    streets: ["Kerkstraat", "Noord Voorstraat", "Zuid Voorstraat", "Industrieweg"],
    facts: ["Binnen de gemeente Hoeksche Waard liggen onder meer Goudswaard, Heinenoord, Klaaswaal.", "Vanaf 's-Gravendeel rijdt u ongeveer 90 kilometer naar Schiphol en 38 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Dordrecht Zuid", "Centrum 's-Gravendeel", "Kerkstraat 's-Gravendeel", "Mookhoek"],
  },
  {
    slug: "s-gravenzande",
    name: "'s-Gravenzande",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 51.9964,
    lng: 4.1626,
    intro:
      "'s-Gravenzande ligt in Zuid-Holland, op ongeveer 62 kilometer van Schiphol en 29 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Korenmolen van 's-Gravenzande", "Hart van 's-Gravenzande (winkelcentrum)", "De Nieuwlandse Molen", "Staelduinsebos (bezienswaardigheid)"],
    streets: ["Molenstraat", "Marktplein", "Havenstraat", "Koningin Wilhelminastraat"],
    facts: ["Binnen de gemeente Westland liggen onder meer De Lier, Honselersdijk, Kwintsheul.", "Vanaf 's-Gravenzande rijdt u ongeveer 62 kilometer naar Schiphol en 29 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Hoek van Holland Haven", "Centrum 's-Gravenzande", "Molenstraat 's-Gravenzande", "Naaldwijk"],
  },
  {
    slug: "aarlanderveen",
    name: "Aarlanderveen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.1326,
    lng: 4.725,
    intro:
      "Aarlanderveen hoort bij de gemeente Alphen aan den Rijn en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Molen No.1", "Molen No.4", "Molen No.2", "Boerderij Verhaar (bezienswaardigheid)"],
    streets: ["Dorpsstraat", "Stationsweg", "A. Honouthof", "Aarlanderveenseweg"],
    facts: ["Binnen de gemeente Alphen aan den Rijn liggen onder meer Alphen aan den Rijn, Benthuizen, Boskoop.", "Vanaf Aarlanderveen rijdt u ongeveer 28 kilometer naar Schiphol en 47 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Alphen aan den Rijn", "Centrum Aarlanderveen", "Dorpsstraat Aarlanderveen", "Zwammerdam"],
  },
  {
    slug: "abbenbroek",
    name: "Abbenbroek",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nissewaard",
    gemeenteUrl: "https://www.nissewaard.nl",
    gemeenteSlug: "nissewaard",
    lat: 51.8412,
    lng: 4.2275,
    intro:
      "Voor bewoners en bezoekers van Abbenbroek is de taxi vaak de snelste verbinding met Schiphol (81 km) en Den Haag (49 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["De Hoop (molen)", "Hillenhoek (natuurgebied)", "Bernisse Molen", "Museum Stadhuis"],
    streets: ["Molenstraat", "Kerkweg", "Schoolstraat", "Lange Boomgaard"],
    facts: ["Vanaf Abbenbroek rijdt u ongeveer 81 kilometer naar Schiphol en 35 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Abbenbroek zijn Heenvliet, Geervliet, Zwartewaal."],
    pickups: ["Centrum Abbenbroek", "Molenstraat Abbenbroek", "Heenvliet"],
  },
  {
    slug: "achthuizen",
    name: "Achthuizen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.6792,
    lng: 4.2779,
    intro:
      "Achthuizen ligt in Zuid-Holland, op ongeveer 104 kilometer van Schiphol en 56 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Windlust (molen)", "Krammerse Slikken (natuurgebied)", "Groote Gat (natuurgebied)", "De Bommelaer (molen)"],
    streets: ["Kerkstraat", "Provincialeweg", "Schoolstraat", "Veerweg"],
    facts: ["Vanaf Achthuizen rijdt u ongeveer 104 kilometer naar Schiphol en 56 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Achthuizen zijn Den Bommel, Ooltgensplaat, Oude-Tonge."],
    pickups: ["Centrum Achthuizen", "Kerkstraat Achthuizen", "Den Bommel"],
  },
  {
    slug: "alblasserdam",
    name: "Alblasserdam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alblasserdam",
    gemeenteUrl: "https://www.alblasserdam.nl",
    gemeenteSlug: "alblasserdam",
    lat: 51.8647,
    lng: 4.6657,
    intro:
      "Alblasserdam is onderdeel van de gemeente Alblasserdam en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Kinderboerderij De Plantage (dierenpark)", "Makado Winkelcentrum", "Souburghse Molen", "Kortlandse Molen"],
    streets: ["Kerkstraat", "Kerkweg", "Havenstraat", "Parallelweg"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Alblasserdam ongeveer 20 kilometer, naar Den Haag 49 kilometer.", "Alblasserdam valt bestuurlijk onder de gemeente Alblasserdam in de provincie Zuid-Holland."],
    pickups: ["Station Zwijndrecht", "Centrum Alblasserdam", "Kerkstraat Alblasserdam", "Kinderdijk"],
  },
  {
    slug: "ammerstol",
    name: "Ammerstol",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.9274,
    lng: 4.807,
    intro:
      "In Ammerstol rijden wij zowel korte ritten binnen de gemeente Krimpenerwaard als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Snakkert (natuurgebied)", "Buitenlanden Ammerstol (natuurgebied)", "Gelkenes Molen", "Hertenkamp Bergambacht (dierenpark)"],
    streets: ["Grote Kerkstraat", "Industrieweg", "Wilhelminastraat"],
    facts: ["Vanaf Ammerstol rijdt u ongeveer 58 kilometer naar Schiphol en 40 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Ammerstol zijn Bergambacht, Groot-Ammers, Streefkerk."],
    pickups: ["Centrum Ammerstol", "Grote Kerkstraat Ammerstol", "Bergambacht"],
  },
  {
    slug: "arkel",
    name: "Arkel",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8657,
    lng: 4.9983,
    intro:
      "Vanuit Arkel (Zuid-Holland) bent u met de taxi in ongeveer 78 kilometer op Schiphol en in 47 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Jan van Arkel (molen)", "Lingebos (natuurgebied)", "Spijksepoort (winkelcentrum)", "Nooit Volmaakt (molen)"],
    streets: ["Stationsweg", "Schoolstraat", "Koningin Julianastraat", "Koningin Wilhelminastraat"],
    facts: ["Buurplaatsen van Arkel zijn Hoogblokland, Gorinchem, Hoornaar.", "Naar het centrum van Rotterdam is het vanuit Arkel ongeveer 47 kilometer, naar Den Haag 76 kilometer."],
    pickups: ["Station Arkel", "Centrum Arkel", "Stationsweg Arkel", "Hoogblokland"],
  },
  {
    slug: "benthuizen",
    name: "Benthuizen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.0807,
    lng: 4.5616,
    intro:
      "Benthuizen is een woonplaats in de gemeente Alphen aan den Rijn en ligt op ongeveer 40 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Molen \"de Haas\"", "Nieuw Leven (molen)", "Stadsboerderij De Weidemolen (dierenpark)", "Historisch Museum Hazerswoude"],
    streets: ["Dorpsstraat", "Molenstraat", "Schoolstraat", "Koningin Julianastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Benthuizen ongeveer 38 kilometer, naar Den Haag 24 kilometer.", "Benthuizen valt bestuurlijk onder de gemeente Alphen aan den Rijn in de provincie Zuid-Holland."],
    pickups: ["Station Willem Dreeslaan", "Centrum Benthuizen", "Dorpsstraat Benthuizen", "Gelderswoude"],
  },
  {
    slug: "bergambacht",
    name: "Bergambacht",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.938,
    lng: 4.7799,
    intro:
      "In Bergambacht rijden wij zowel korte ritten binnen de gemeente Krimpenerwaard als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Den Arend (molen)", "Hertenkamp Bergambacht (dierenpark)", "De Snakkert (natuurgebied)", "Buitenlanden Bergambacht (natuurgebied)"],
    streets: ["Hoofdstraat", "Provincialeweg", "Voorstraat", "Marktplein"],
    facts: ["Bergambacht valt bestuurlijk onder de gemeente Krimpenerwaard in de provincie Zuid-Holland.", "Binnen de gemeente Krimpenerwaard liggen onder meer Ammerstol, Berkenwoude, Gouderak."],
    pickups: ["Centrum Bergambacht", "Hoofdstraat Bergambacht", "Ammerstol"],
  },
  {
    slug: "bergschenhoek",
    name: "Bergschenhoek",
    province: "Zuid-Holland",
    gemeente: "Gemeente Lansingerland",
    gemeenteUrl: "https://www.lansingerland.nl",
    gemeenteSlug: "lansingerland",
    lat: 51.9822,
    lng: 4.5112,
    intro:
      "Wie in Bergschenhoek vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Polderhuis (landhuis)", "Dierenweide (dierenpark)", "Stadsboerderij \"De Blijde Wei\" (dierenpark)", "Winkelcentrum Westerwater"],
    streets: ["Dorpsstraat", "Kerkstraat", "Wilhelminastraat", "Burgemeester van Meetelenstraat"],
    facts: ["Binnen de gemeente Lansingerland liggen onder meer Berkel en Rodenrijs, Bleiswijk.", "Vanaf Bergschenhoek rijdt u ongeveer 61 kilometer naar Schiphol en 9 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Binnenhof", "Centrum Bergschenhoek", "Dorpsstraat Bergschenhoek", "Berkel en Rodenrijs"],
  },
  {
    slug: "berkenwoude",
    name: "Berkenwoude",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.9529,
    lng: 4.6995,
    intro:
      "Vanuit Berkenwoude (Zuid-Holland) bent u met de taxi in ongeveer 53 kilometer op Schiphol en in 33 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Berkenwoudse Driehoek (natuurgebied)", "Polder de Nesse (natuurgebied)", "Commissarissenlanden (natuurgebied)", "Berkenwoudse Boezem (natuurgebied)"],
    streets: ["Dorpsstraat", "Kerkweg", "Koningin Julianastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Berkenwoude ongeveer 33 kilometer, naar Den Haag 41 kilometer.", "Berkenwoude valt bestuurlijk onder de gemeente Krimpenerwaard in de provincie Zuid-Holland."],
    pickups: ["Station Nieuwerkerk aan den IJssel", "Centrum Berkenwoude", "Dorpsstraat Berkenwoude", "Ouderkerk aan den IJssel"],
  },
  {
    slug: "bleiswijk",
    name: "Bleiswijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Lansingerland",
    gemeenteUrl: "https://www.lansingerland.nl",
    gemeenteSlug: "lansingerland",
    lat: 52.0225,
    lng: 4.5345,
    intro:
      "Bleiswijk is een woonplaats in de gemeente Lansingerland en ligt op ongeveer 53 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["OVMB (museum)", "Bleiswijkse Verlaat (bezienswaardigheid)", "Tweemanspolder Molen Nummer 4", "Tweemanspolder Molen Nummer 3"],
    streets: ["Dorpsstraat", "Kerkstraat", "Julianastraat", "Wilhelminastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Bleiswijk ongeveer 23 kilometer, naar Den Haag 21 kilometer.", "Bleiswijk valt bestuurlijk onder de gemeente Lansingerland in de provincie Zuid-Holland."],
    pickups: ["Station Lansingerland-Zoetermeer", "Centrum Bleiswijk", "Dorpsstraat Bleiswijk", "Zevenhuizen"],
  },
  {
    slug: "bleskensgraaf-ca",
    name: "Bleskensgraaf ca",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8687,
    lng: 4.7675,
    intro:
      "Bleskensgraaf ca is onderdeel van de gemeente Molenlanden en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["De Vriendschap (molen)", "Hofwegensemolen", "Donkse Laagten (natuurgebied)", "Broekmolen"],
    streets: ["Dorpsstraat", "Kerkstraat", "Provincialeweg N428", "Burgemeester Dekkingstraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Bleskensgraaf ca ongeveer 28 kilometer, naar Den Haag 57 kilometer.", "Bleskensgraaf ca valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland."],
    pickups: ["Station Sliedrecht", "Centrum Bleskensgraaf ca", "Dorpsstraat Bleskensgraaf ca", "Wijngaarden"],
  },
  {
    slug: "bodegraven",
    name: "Bodegraven",
    province: "Zuid-Holland",
    gemeente: "Gemeente Bodegraven-Reeuwijk",
    gemeenteUrl: "https://www.bodegraven-reeuwijk.nl",
    gemeenteSlug: "bodegraven-reeuwijk",
    lat: 52.091,
    lng: 4.7598,
    intro:
      "Bodegraven is onderdeel van de gemeente Bodegraven-Reeuwijk en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["De Arkduif (molen)", "De Oude Zustertuin (dierenpark)", "Geiten (bezienswaardigheid)", "Rijnhoek Plaza (winkelcentrum)"],
    streets: ["Kerkstraat", "Stationsweg", "Marktstraat", "Nieuwe Markt"],
    facts: ["Binnen de gemeente Bodegraven-Reeuwijk liggen onder meer Driebruggen, Nieuwerbrug aan den Rijn, Reeuwijk.", "Vanaf Bodegraven rijdt u ongeveer 36 kilometer naar Schiphol en 36 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Bodegraven", "Centrum Bodegraven", "Kerkstraat Bodegraven", "Zwammerdam"],
  },
  {
    slug: "boskoop",
    name: "Boskoop",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.0814,
    lng: 4.6707,
    intro:
      "Voor bewoners en bezoekers van Boskoop is de taxi vaak de snelste verbinding met Schiphol (34 km) en Den Haag (32 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Boomkwekerijmuseum", "Kinderboerderij Contactweide (dierenpark)", "Spijkerboorse Kade (natuurgebied)", "Voorofsche Polder (natuurgebied)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Provincialeweg", "Dwars Nieuwstraat"],
    facts: ["Vanaf Boskoop rijdt u ongeveer 34 kilometer naar Schiphol en 34 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Boskoop zijn Zwammerdam, Waddinxveen, Alphen aan den Rijn."],
    pickups: ["Station Boskoop", "Centrum Boskoop", "Dorpsstraat Boskoop", "Zwammerdam"],
  },
  {
    slug: "brandwijk",
    name: "Brandwijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8897,
    lng: 4.8122,
    intro:
      "Brandwijk hoort bij de gemeente Molenlanden en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Kerkmolen", "Achterlandse Molen", "Hofwegensemolen", "De Middelmolen"],
    streets: ["Kerkweg", "Julianastraat", "Ammersekade", "Anemoon"],
    facts: ["Brandwijk valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland.", "Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Giessenburg."],
    pickups: ["Centrum Brandwijk", "Kerkweg Brandwijk", "Molenaarsgraaf"],
  },
  {
    slug: "brielle",
    name: "Brielle",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.9067,
    lng: 4.1668,
    intro:
      "Vanuit Brielle (Zuid-Holland) bent u met de taxi in ongeveer 76 kilometer op Schiphol en in 28 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["'t Vliegend Hert (molen)", "vestingwerken van Brielle (kasteel)", "Historisch Museum Den Briel", "Brigittenpoortje (bezienswaardigheid)"],
    streets: ["Kerkstraat", "Molenstraat", "Voorstraat", "Markt"],
    facts: ["Vanaf Brielle rijdt u ongeveer 76 kilometer naar Schiphol en 29 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Brielle zijn Vierpolders, Tinte, Rozenburg."],
    pickups: ["Station Steendijkpolder", "Centrum Brielle", "Kerkstraat Brielle", "Vierpolders"],
  },
  {
    slug: "cortelande",
    name: "Cortelande",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zuidplas",
    gemeenteUrl: "https://www.zuidplas.nl",
    gemeenteSlug: "zuidplas",
    lat: 52.0044,
    lng: 4.6298,
    intro:
      "Voor bewoners en bezoekers van Cortelande is de taxi vaak de snelste verbinding met Schiphol (59 km) en Den Haag (27 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Monument Laagste Punt van Nederland (bezienswaardigheid)", "Historisch Centrum Ons Verleden (museum)", "Windlust (molen)", "GoStores Gouda (winkelcentrum)"],
    streets: ["Parallelweg-Noord", "Bredeweg", "Middelweg"],
    facts: ["Buurplaatsen van Cortelande zijn Moordrecht, Zevenhuizen, Waddinxveen.", "Naar het centrum van Rotterdam is het vanuit Cortelande ongeveer 22 kilometer, naar Den Haag 27 kilometer."],
    pickups: ["Station Waddinxveen Triangel", "Centrum Cortelande", "Parallelweg-Noord Cortelande", "Moordrecht"],
  },
  {
    slug: "dalem",
    name: "Dalem",
    province: "Zuid-Holland",
    gemeente: "Gemeente Gorinchem",
    gemeenteUrl: "https://www.gorinchem.nl",
    gemeenteSlug: "gorinchem",
    lat: 51.8241,
    lng: 5.0143,
    intro:
      "Dalem is onderdeel van de gemeente Gorinchem en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Slot Loevestein (kasteel)", "Museum Slot Loevestein", "Jacoba van Beierenhuis (landhuis)", "Loevesteinsepoort (bezienswaardigheid)"],
    streets: ["Beatrixlaan", "Dalemse Zeiving", "De Bongerd", "De Wetering"],
    facts: ["Vanaf Dalem rijdt u ongeveer 85 kilometer naar Schiphol en 56 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Dalem zijn Gorinchem, Arkel, Schelluinen."],
    pickups: ["Station Gorinchem", "Centrum Dalem", "Beatrixlaan Dalem", "Gorinchem"],
  },
  {
    slug: "de-lier",
    name: "De Lier",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 51.9747,
    lng: 4.2558,
    intro:
      "Wie in De Lier vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Het Westlants Schaatsmuseum", "Museum De Timmerwerf", "Kinderboerderij (dierenpark)", "De Zeven Gaten (natuurgebied)"],
    streets: ["Hoofdstraat", "Molenstraat", "Schoolstraat", "Koningin Wilhelminastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit De Lier ongeveer 26 kilometer, naar Den Haag 22 kilometer.", "De Lier valt bestuurlijk onder de gemeente Westland in de provincie Zuid-Holland."],
    pickups: ["Station Steendijkpolder", "Centrum De Lier", "Hoofdstraat De Lier", "Maasdijk"],
  },
  {
    slug: "de-zilk",
    name: "De Zilk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Noordwijk",
    gemeenteUrl: "https://www.noordwijk.nl",
    gemeenteSlug: "noordwijk",
    lat: 52.3002,
    lng: 4.5411,
    intro:
      "De Zilk hoort bij de gemeente Noordwijk en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Kabouterdorp De Zilk (bezienswaardigheid)", "The Tulip Barn (bezienswaardigheid)", "Tulip Experience Amsterdam (bezienswaardigheid)", "Kabouterdorp Lisse (bezienswaardigheid)"],
    streets: ["Provincialeweg", "Fietspad Langeveld", "Beeklaan", "Beukenlaan"],
    facts: ["Binnen de gemeente Noordwijk liggen onder meer Noordwijk, Noordwijkerhout.", "Vanaf De Zilk rijdt u ongeveer 23 kilometer naar Schiphol en 50 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Hillegom", "Centrum De Zilk", "Provincialeweg De Zilk", "Hillegom"],
  },
  {
    slug: "delfgauw",
    name: "Delfgauw",
    province: "Zuid-Holland",
    gemeente: "Gemeente Pijnacker-Nootdorp",
    gemeenteUrl: "https://www.pijnacker-nootdorp.nl",
    gemeenteSlug: "pijnacker-nootdorp",
    lat: 52.0032,
    lng: 4.402,
    intro:
      "Delfgauw is onderdeel van de gemeente Pijnacker-Nootdorp en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Science Centre Delft (museum)", "Intelligent Bicycle Path (bezienswaardigheid)", "De Wisselvalligheid (natuurgebied)", "Arboretum-Heempark Delft (bezienswaardigheid)"],
    streets: ["Rijksstraatweg", "Burgemeester Merkusstraat", "Burgemeester Molenbroekstraat", "Burgemeester Scholtenstraat"],
    facts: ["Buurplaatsen van Delfgauw zijn Pijnacker, Delft, Nootdorp.", "Naar het centrum van Rotterdam is het vanuit Delfgauw ongeveer 17 kilometer, naar Den Haag 17 kilometer."],
    pickups: ["Station Delft Campus", "Centrum Delfgauw", "Rijksstraatweg Delfgauw", "Pijnacker"],
  },
  {
    slug: "den-bommel",
    name: "Den Bommel",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7083,
    lng: 4.2929,
    intro:
      "In Den Bommel rijden wij zowel korte ritten binnen de gemeente Goeree-Overflakkee als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Bommelaer (molen)", "Windlust (molen)", "Groote Gat (natuurgebied)", "Ventjagersgaatje (natuurgebied)"],
    streets: ["Provincialeweg", "Voorstraat", "Schoolstraat", "Julianastraat"],
    facts: ["Buurplaatsen van Den Bommel zijn Achthuizen, Ooltgensplaat, Stad aan 't Haringvliet.", "Naar het centrum van Rotterdam is het vanuit Den Bommel ongeveer 37 kilometer, naar Den Haag 69 kilometer."],
    pickups: ["Centrum Den Bommel", "Provincialeweg Den Bommel", "Achthuizen"],
  },
  {
    slug: "den-hoorn",
    name: "Den Hoorn",
    province: "Zuid-Holland",
    gemeente: "Gemeente Midden-Delfland",
    gemeenteUrl: "https://www.middendelfland.nl",
    gemeenteSlug: "midden-delfland",
    lat: 52.0054,
    lng: 4.3174,
    intro:
      "In Den Hoorn rijden wij zowel korte ritten binnen de gemeente Midden-Delfland als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Woudse Bos (natuurgebied)", "Dierenweide Oranjelaan (dierenpark)", "Zuyd Maatje (dierenpark)", "De Schaapweimolen"],
    streets: ["Kerkstraat", "Rijksstraatweg", "Schoolstraat", "Herenstraat"],
    facts: ["Den Hoorn valt bestuurlijk onder de gemeente Midden-Delfland in de provincie Zuid-Holland.", "Binnen de gemeente Midden-Delfland liggen onder meer Maasland, Schipluiden."],
    pickups: ["Station Delft", "Centrum Den Hoorn", "Kerkstraat Den Hoorn", "Wateringen"],
  },
  {
    slug: "dirksland",
    name: "Dirksland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7562,
    lng: 4.0866,
    intro:
      "Dirksland is een woonplaats in de gemeente Goeree-Overflakkee en ligt op ongeveer 99 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["De Eendracht (molen)", "Het Hof (landhuis)", "De Korenbloem (molen)", "Streekmuseum"],
    streets: ["Stationsweg", "Voorstraat", "Nieuwstraat", "Westdijk"],
    facts: ["Dirksland valt bestuurlijk onder de gemeente Goeree-Overflakkee in de provincie Zuid-Holland.", "Binnen de gemeente Goeree-Overflakkee liggen onder meer Achthuizen, Den Bommel, Goedereede."],
    pickups: ["Centrum Dirksland", "Stationsweg Dirksland", "Melissant"],
  },
  {
    slug: "driebruggen",
    name: "Driebruggen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Bodegraven-Reeuwijk",
    gemeenteUrl: "https://www.bodegraven-reeuwijk.nl",
    gemeenteSlug: "bodegraven-reeuwijk",
    lat: 52.0451,
    lng: 4.7942,
    intro:
      "In Driebruggen rijden wij zowel korte ritten binnen de gemeente Bodegraven-Reeuwijk als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Oukoopse Molen", "Geriefbos Waarder (natuurgebied)", "De Weijpoortsche Molen", "Lopikerwaard (natuurgebied)"],
    streets: ["Kerkweg", "Schoolstraat", "Burgemeester Brinkmanhof", "Burgemeester Doormanstraat"],
    facts: ["Driebruggen valt bestuurlijk onder de gemeente Bodegraven-Reeuwijk in de provincie Zuid-Holland.", "Binnen de gemeente Bodegraven-Reeuwijk liggen onder meer Bodegraven, Nieuwerbrug aan den Rijn, Reeuwijk."],
    pickups: ["Station Gouda Goverwelle", "Centrum Driebruggen", "Kerkweg Driebruggen", "Waarder"],
  },
  {
    slug: "geervliet",
    name: "Geervliet",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nissewaard",
    gemeenteUrl: "https://www.nissewaard.nl",
    gemeenteSlug: "nissewaard",
    lat: 51.8544,
    lng: 4.2657,
    intro:
      "Geervliet is onderdeel van de gemeente Nissewaard en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Bernisse Molen", "Museum Stadhuis", "De Hoop (molen)", "Fluisterboot de IJsvogel (bezienswaardigheid)"],
    streets: ["Kerkstraat", "Molenstraat", "Schoolstraat", "Burgemeester van der Minnelaan"],
    facts: ["Buurplaatsen van Geervliet zijn Heenvliet, Abbenbroek, Simonshaven.", "Naar het centrum van Rotterdam is het vanuit Geervliet ongeveer 26 kilometer, naar Den Haag 41 kilometer."],
    pickups: ["Station De Akkers", "Centrum Geervliet", "Kerkstraat Geervliet", "Heenvliet"],
  },
  {
    slug: "gelderswoude",
    name: "Gelderswoude",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zoeterwoude",
    gemeenteUrl: "https://www.zoeterwoude.nl",
    gemeenteSlug: "zoeterwoude",
    lat: 52.0912,
    lng: 4.5267,
    intro:
      "Wie in Gelderswoude vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Rondvaart Zoetermeer (bezienswaardigheid)", "'t Geertje (dierenpark)", "Noord Aa (natuurgebied)", "Molen \"de Haas\""],
    streets: ["Gelderswoudsekerkpad", "Gelderswoudseweg", "Molenslootpad", "Slootweg"],
    facts: ["Vanaf Gelderswoude rijdt u ongeveer 34 kilometer naar Schiphol en 22 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Gelderswoude zijn Benthuizen, Zoeterwoude, Zoetermeer."],
    pickups: ["Station Leidsewallen", "Centrum Gelderswoude", "Gelderswoudsekerkpad Gelderswoude", "Benthuizen"],
  },
  {
    slug: "giessenburg",
    name: "Giessenburg",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8567,
    lng: 4.8829,
    intro:
      "In Giessenburg rijden wij zowel korte ritten binnen de gemeente Molenlanden als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Scheiwijkse Molen", "Kasteel Schelluinen", "Tiendwegse Molen", "Museum De Koperen Knop"],
    streets: ["Dorpsstraat", "Provincialeweg", "Kerkweg", "Molenweg"],
    facts: ["Buurplaatsen van Giessenburg zijn Schelluinen, Hardinxveld-Giessendam, Ottoland.", "Naar het centrum van Rotterdam is het vanuit Giessenburg ongeveer 36 kilometer, naar Den Haag 66 kilometer."],
    pickups: ["Station Boven Hardinxveld", "Centrum Giessenburg", "Dorpsstraat Giessenburg", "Schelluinen"],
  },
  {
    slug: "goedereede",
    name: "Goedereede",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.8184,
    lng: 3.9897,
    intro:
      "Goedereede ligt in Zuid-Holland, op ongeveer 91 kilometer van Schiphol en 43 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Torenmuseum", "Windvang (molen)", "Koudenhoek (natuurgebied)", "Korenlust (molen)"],
    streets: ["Kerkstraat", "Molenstraat", "Provincialeweg", "Markt"],
    facts: ["Binnen de gemeente Goeree-Overflakkee liggen onder meer Achthuizen, Den Bommel, Dirksland.", "Vanaf Goedereede rijdt u ongeveer 91 kilometer naar Schiphol en 43 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Goedereede", "Kerkstraat Goedereede", "Stellendam"],
  },
  {
    slug: "gouderak",
    name: "Gouderak",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.9823,
    lng: 4.6899,
    intro:
      "Wie in Gouderak vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Middelblok (natuurgebied)", "Kattendijksblokboezem (natuurgebied)", "Dino Experience Park (attractiepark)", "Polder de Nesse (natuurgebied)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Schoolstraat", "Lange Rol"],
    facts: ["Vanaf Gouderak rijdt u ongeveer 47 kilometer naar Schiphol en 28 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Gouderak zijn Moordrecht, Berkenwoude, Gouda."],
    pickups: ["Station Gouda", "Centrum Gouderak", "Dorpsstraat Gouderak", "Moordrecht"],
  },
  {
    slug: "goudriaan",
    name: "Goudriaan",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.9036,
    lng: 4.9053,
    intro:
      "Goudriaan is een woonplaats in de gemeente Molenlanden en ligt op ongeveer 80 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Goudriaanse Molen", "Smoutjes Vlietlanden (natuurgebied)", "De Westermolen", "Schaapskooi Ottoland (dierenpark)"],
    streets: ["Burgemeester van Slijpestraat", "Raadhuisstraat", "Boonevlietweg", "Brederodeplein"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Goudriaan ongeveer 40 kilometer, naar Den Haag 70 kilometer.", "Goudriaan valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland."],
    pickups: ["Centrum Goudriaan", "Burgemeester van Slijpestraat Goudriaan", "Noordeloos"],
  },
  {
    slug: "goudswaard",
    name: "Goudswaard",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7712,
    lng: 4.2764,
    intro:
      "Goudswaard ligt in Zuid-Holland, op ongeveer 100 kilometer van Schiphol en 52 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Korendijkse Slikken (natuurgebied)", "Leenheeren Gorzenpolder (natuurgebied)", "Windlust (molen)", "Simonia (molen)"],
    streets: ["Dorpsstraat", "Nieuwstraat", "Koningin Julianastraat", "Burgemeester Kolbach erf"],
    facts: ["Binnen de gemeente Hoeksche Waard liggen onder meer 's-Gravendeel, Heinenoord, Klaaswaal.", "Vanaf Goudswaard rijdt u ongeveer 100 kilometer naar Schiphol en 52 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Goudswaard", "Dorpsstraat Goudswaard", "Piershil"],
  },
  {
    slug: "groot-ammers",
    name: "Groot-Ammers",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.9193,
    lng: 4.8509,
    intro:
      "Vanuit Groot-Ammers (Zuid-Holland) bent u met de taxi in ongeveer 84 kilometer op Schiphol en in 39 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Trekkerbaan (bezienswaardigheid)", "Ponyrijden (bezienswaardigheid)", "Avonturenboerderij Molenwaard (attractiepark)", "De Jonge Sophia (molen)"],
    streets: ["Kerkstraat", "Voorstraat", "Julianastraat", "Wilhelminastraat"],
    facts: ["Vanaf Groot-Ammers rijdt u ongeveer 84 kilometer naar Schiphol en 49 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Groot-Ammers zijn Nieuwpoort, Ammerstol, Schoonhoven."],
    pickups: ["Centrum Groot-Ammers", "Kerkstraat Groot-Ammers", "Nieuwpoort"],
  },
  {
    slug: "haastrecht",
    name: "Haastrecht",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 52.0036,
    lng: 4.7914,
    intro:
      "Voor bewoners en bezoekers van Haastrecht is de taxi vaak de snelste verbinding met Schiphol (54 km) en Den Haag (40 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Hooge Boezem achter Haastecht (natuurgebied)", "Gemaal De Hooge Boezem (museum)", "Boezemmolen nr. 6", "Paulina Bisdom Van Vliet (museum)"],
    streets: ["Kerkstraat", "Provincialeweg Oost", "Provincialeweg West", "Provincialeweg"],
    facts: ["Binnen de gemeente Krimpenerwaard liggen onder meer Ammerstol, Bergambacht, Berkenwoude.", "Vanaf Haastrecht rijdt u ongeveer 54 kilometer naar Schiphol en 33 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Gouda Goverwelle", "Centrum Haastrecht", "Kerkstraat Haastrecht", "Vlist"],
  },
  {
    slug: "hardinxveld-giessendam",
    name: "Hardinxveld-Giessendam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hardinxveld-Giessendam",
    gemeenteUrl: "https://www.hardinxveld-giessendam.nl",
    gemeenteSlug: "hardinxveld-giessendam",
    lat: 51.8326,
    lng: 4.8524,
    intro:
      "Hardinxveld-Giessendam hoort bij de gemeente Hardinxveld-Giessendam en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Museum De Koperen Knop", "Tiendwegse Molen", "Kinderboederij \"Floreffehoeve\" (dierenpark)", "Kinderboerderij 'De Hooizolder' (dierenpark)"],
    streets: ["Molenstraat", "Stationsstraat", "Kerkweg", "Havenstraat"],
    facts: ["Hardinxveld-Giessendam vormt een eigen woonplaats binnen de gemeente Hardinxveld-Giessendam.", "Vanaf Hardinxveld-Giessendam rijdt u ongeveer 87 kilometer naar Schiphol en 44 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Hardinxveld-Giessendam", "Centrum Hardinxveld-Giessendam", "Molenstraat Hardinxveld-Giessendam", "Giessenburg"],
  },
  {
    slug: "hazerswoude-dorp",
    name: "Hazerswoude-Dorp",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.0999,
    lng: 4.5918,
    intro:
      "Hazerswoude-Dorp ligt in Zuid-Holland, op ongeveer 35 kilometer van Schiphol en 37 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Historisch Museum Hazerswoude", "Nieuw Leven (molen)", "Gere Molen", "Rietveldse Molen"],
    streets: ["Dorpsstraat", "Provincialeweg", "Burgemeester den Hollanderweg", "Burgemeester Smitweg"],
    facts: ["Binnen de gemeente Alphen aan den Rijn liggen onder meer Aarlanderveen, Alphen aan den Rijn, Benthuizen.", "Vanaf Hazerswoude-Dorp rijdt u ongeveer 35 kilometer naar Schiphol en 37 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Boskoop", "Centrum Hazerswoude-Dorp", "Dorpsstraat Hazerswoude-Dorp", "Hazerswoude-Rijndijk"],
  },
  {
    slug: "hazerswoude-rijndijk",
    name: "Hazerswoude-Rijndijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.1254,
    lng: 4.5941,
    intro:
      "Hazerswoude-Rijndijk ligt in Zuid-Holland, op ongeveer 35 kilometer van Schiphol en 36 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["De Rijnenburger (molen)", "Rooie Wip (molen)", "Spookverlaat (natuurgebied)", "Hondsdijkse Molen"],
    streets: ["Stationsweg", "Langerodepad", "Albert Verweijstraat", "Alphen aan de Rijn-West 8"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Hazerswoude-Rijndijk ongeveer 42 kilometer, naar Den Haag 27 kilometer.", "Hazerswoude-Rijndijk valt bestuurlijk onder de gemeente Alphen aan den Rijn in de provincie Zuid-Holland."],
    pickups: ["Station Alphen aan den Rijn", "Centrum Hazerswoude-Rijndijk", "Stationsweg Hazerswoude-Rijndijk", "Koudekerk aan den Rijn"],
  },
  {
    slug: "heenvliet",
    name: "Heenvliet",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nissewaard",
    gemeenteUrl: "https://www.nissewaard.nl",
    gemeenteSlug: "nissewaard",
    lat: 51.86,
    lng: 4.2246,
    intro:
      "In Heenvliet rijden wij zowel korte ritten binnen de gemeente Nissewaard als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Hillenhoek (natuurgebied)", "Blanke Waal (natuurgebied)", "Holle Mare (natuurgebied)", "De Hoop (molen)"],
    streets: ["Stationsweg", "Markt", "Kerkweg", "Nieuwstraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Heenvliet ongeveer 29 kilometer, naar Den Haag 45 kilometer.", "Heenvliet valt bestuurlijk onder de gemeente Nissewaard in de provincie Zuid-Holland."],
    pickups: ["Centrum Heenvliet", "Stationsweg Heenvliet", "Zwartewaal"],
  },
  {
    slug: "heerjansdam",
    name: "Heerjansdam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zwijndrecht",
    gemeenteUrl: "https://www.zwijndrecht.nl",
    gemeenteSlug: "zwijndrecht",
    lat: 51.8304,
    lng: 4.5734,
    intro:
      "Heerjansdam hoort bij de gemeente Zwijndrecht en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Het Nieuwe Poldertje (natuurgebied)", "De Kersenboom (molen)", "Museum Johannes Postschool", "Korenmolen De Lelie (bezienswaardigheid)"],
    streets: ["Dorpsstraat", "Molenweg", "Industrieweg", "Julianastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Heerjansdam ongeveer 21 kilometer, naar Den Haag 47 kilometer.", "Heerjansdam valt bestuurlijk onder de gemeente Zwijndrecht in de provincie Zuid-Holland."],
    pickups: ["Station Barendrecht", "Centrum Heerjansdam", "Dorpsstraat Heerjansdam", "Puttershoek"],
  },
  {
    slug: "heinenoord",
    name: "Heinenoord",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.8227,
    lng: 4.5046,
    intro:
      "Heinenoord ligt in Zuid-Holland, op ongeveer 81 kilometer van Schiphol en 33 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Witte Boerderij (winkelcentrum)", "Oost-Leeuwenstein (museum)", "Attractiepark Binnenmaas", "Kinderboerderij Binnenmaas (dierenpark)"],
    streets: ["Dorpsstraat", "Provincialeweg", "Molenweg", "Julianastraat"],
    facts: ["Buurplaatsen van Heinenoord zijn Mijnsheerenland, Barendrecht, Westmaas.", "Naar het centrum van Rotterdam is het vanuit Heinenoord ongeveer 17 kilometer, naar Den Haag 49 kilometer."],
    pickups: ["Station Barendrecht", "Centrum Heinenoord", "Dorpsstraat Heinenoord", "Mijnsheerenland"],
  },
  {
    slug: "hekelingen",
    name: "Hekelingen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nissewaard",
    gemeenteUrl: "https://www.nissewaard.nl",
    gemeenteSlug: "nissewaard",
    lat: 51.8223,
    lng: 4.3411,
    intro:
      "Wie in Hekelingen vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Kinderboerderij Nieuw-Beijerland (dierenpark)", "De Swaen (molen)", "Winkelcentrum Sterrenhof", "Kinderboerderij De Trotse Pauw (dierenpark)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Westdijk", "Lange Putseweg"],
    facts: ["Vanaf Hekelingen rijdt u ongeveer 76 kilometer naar Schiphol en 29 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Hekelingen zijn Spijkenisse, Piershil, Nieuw-Beijerland."],
    pickups: ["Station Heemraadlaan", "Centrum Hekelingen", "Dorpsstraat Hekelingen", "Spijkenisse"],
  },
  {
    slug: "hendrik-ido-ambacht",
    name: "Hendrik-Ido-Ambacht",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hendrik-Ido-Ambacht",
    gemeenteUrl: "https://www.h-i-ambacht.nl",
    gemeenteSlug: "hendrik-ido-ambacht",
    lat: 51.8418,
    lng: 4.6388,
    intro:
      "Hendrik-Ido-Ambacht is onderdeel van de gemeente Hendrik-Ido-Ambacht en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Jeugdspeelpark (dierenpark)", "Sophiapolder (natuurgebied)", "Winkelcentrum Walburg", "Crezéepolder (natuurgebied)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Rijksstraatweg", "Burgemeester Broekhuisplein"],
    facts: ["Buurplaatsen van Hendrik-Ido-Ambacht zijn Zwijndrecht, Alblasserdam, Ridderkerk.", "Naar het centrum van Rotterdam is het vanuit Hendrik-Ido-Ambacht ongeveer 18 kilometer, naar Den Haag 47 kilometer."],
    pickups: ["Station Zwijndrecht", "Centrum Hendrik-Ido-Ambacht", "Dorpsstraat Hendrik-Ido-Ambacht", "Zwijndrecht"],
  },
  {
    slug: "herkingen",
    name: "Herkingen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7098,
    lng: 4.0796,
    intro:
      "Herkingen ligt in Zuid-Holland, op ongeveer 105 kilometer van Schiphol en 57 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["De Dankbaarheid (molen)", "Paardengat (natuurgebied)", "De Eendracht (molen)", "Faunapark (dierenpark)"],
    streets: ["Nieuwstraat", "Westdijk", "1 februariweg", "Adoptieplein"],
    facts: ["Vanaf Herkingen rijdt u ongeveer 105 kilometer naar Schiphol en 57 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Herkingen zijn Nieuwe-Tonge, Dirksland, Melissant."],
    pickups: ["Centrum Herkingen", "Nieuwstraat Herkingen", "Nieuwe-Tonge"],
  },
  {
    slug: "hillegom",
    name: "Hillegom",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hillegom",
    gemeenteUrl: "https://www.hillegom.nl",
    gemeenteSlug: "hillegom",
    lat: 52.2968,
    lng: 4.577,
    intro:
      "Vanuit Hillegom (Zuid-Holland) bent u met de taxi in ongeveer 21 kilometer op Schiphol en in 58 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Oude Pomp (bezienswaardigheid)", "The Tulip Barn (bezienswaardigheid)", "Vosse- en Weerlanerpolder (natuurgebied)", "Kabouterdorp Lisse (bezienswaardigheid)"],
    streets: ["Hoofdstraat", "Kerkstraat", "Molenstraat", "Stationsweg"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Hillegom ongeveer 58 kilometer, naar Den Haag 44 kilometer.", "Hillegom valt bestuurlijk onder de gemeente Hillegom in de provincie Zuid-Holland."],
    pickups: ["Station Hillegom", "Centrum Hillegom", "Hoofdstraat Hillegom", "De Zilk"],
  },
  {
    slug: "hoek-van-holland",
    name: "Hoek van Holland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Rotterdam",
    gemeenteUrl: "https://www.rotterdam.nl",
    gemeenteSlug: "rotterdam",
    lat: 51.9798,
    lng: 4.1235,
    intro:
      "Wie in Hoek van Holland vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Fort aan den Hoek van Holland (museum)", "Hoekse Bosjes (natuurgebied)", "Vinetaduin (natuurgebied)", "Nederlands Militair Kustverdedigingsmuseum"],
    streets: ["Stationsweg", "Kleine Schoolstraat", "Schoolstraat", "Langeweg"],
    facts: ["Hoek van Holland valt bestuurlijk onder de gemeente Rotterdam in de provincie Zuid-Holland.", "Binnen de gemeente Rotterdam liggen onder meer Botlek Rotterdam, Europoort Rotterdam, Hoogvliet Rotterdam."],
    pickups: ["Station Hoek van Holland Haven", "Centrum Hoek van Holland", "Stationsweg Hoek van Holland", "'s-Gravenzande"],
  },
  {
    slug: "honselersdijk",
    name: "Honselersdijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 52.0055,
    lng: 4.2358,
    intro:
      "Vanuit Honselersdijk (Zuid-Holland) bent u met de taxi in ongeveer 58 kilometer op Schiphol en in 27 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Westlands Museum", "Kinderboerderij SKiP (dierenpark)", "Woonboulevard Naaldwijk (winkelcentrum)", "De Zeven Gaten (natuurgebied)"],
    streets: ["Stationsweg", "Burgemeester Elsenweg", "Burgemeester Hoogenboomstraat"],
    facts: ["Buurplaatsen van Honselersdijk zijn Kwintsheul, Naaldwijk, Poeldijk.", "Naar het centrum van Rotterdam is het vanuit Honselersdijk ongeveer 27 kilometer, naar Den Haag 17 kilometer."],
    pickups: ["Centrum Honselersdijk", "Stationsweg Honselersdijk", "Kwintsheul"],
  },
  {
    slug: "hoogblokland",
    name: "Hoogblokland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8813,
    lng: 4.9763,
    intro:
      "Hoogblokland is een woonplaats in de gemeente Molenlanden en ligt op ongeveer 75 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Jan van Arkel (molen)", "Boterslootse Molen", "Put van Zessen (natuurgebied)", "Oudendijkse Molen"],
    streets: ["Provincialeweg", "Schoolstraat", "'t Hoekje", "'t Hoog"],
    facts: ["Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk.", "Vanaf Hoogblokland rijdt u ongeveer 75 kilometer naar Schiphol en 58 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Arkel", "Centrum Hoogblokland", "Provincialeweg Hoogblokland", "Arkel"],
  },
  {
    slug: "hoogmade",
    name: "Hoogmade",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.165,
    lng: 4.5839,
    intro:
      "In Hoogmade rijden wij zowel korte ritten binnen de gemeente Kaag en Braassem als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Grosmolen", "Vlietmolen", "Hoogmadese molen", "Kalkmolen"],
    streets: ["Kerkstraat", "Oude Kerkweg", "Parallelweg"],
    facts: ["Hoogmade valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland.", "Binnen de gemeente Kaag en Braassem liggen onder meer Kaag, Leimuiden, Nieuwe Wetering."],
    pickups: ["Centrum Hoogmade", "Kerkstraat Hoogmade", "Koudekerk aan den Rijn"],
  },
  {
    slug: "hoogvliet-rotterdam",
    name: "Hoogvliet Rotterdam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Rotterdam",
    gemeenteUrl: "https://www.rotterdam.nl",
    gemeenteSlug: "rotterdam",
    lat: 51.8622,
    lng: 4.3634,
    intro:
      "In Hoogvliet Rotterdam rijden wij zowel korte ritten binnen de gemeente Rotterdam als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Meeuwenpunt (winkelcentrum)", "Kinderboerderij De Oedenstee (dierenpark)", "Oude Spijkenisserbrug (bezienswaardigheid)", "Nooitgedacht (molen)"],
    streets: ["Dorpsstraat", "Langebakkersoord", "Nieuwe Langeweg"],
    facts: ["Vanaf Hoogvliet Rotterdam rijdt u ongeveer 67 kilometer naar Schiphol en 20 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Hoogvliet Rotterdam zijn Spijkenisse, Poortugaal, Pernis Rotterdam."],
    pickups: ["Station Hoogvliet", "Centrum Hoogvliet Rotterdam", "Dorpsstraat Hoogvliet Rotterdam", "Spijkenisse"],
  },
  {
    slug: "hoornaar",
    name: "Hoornaar",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8733,
    lng: 4.9388,
    intro:
      "Wie in Hoornaar vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Oudendijkse Molen", "Scheiwijkse Molen", "Boterslootse Molen", "Kasteel Schelluinen"],
    streets: ["De Schans", "De zes molens", "Dirk IV-plein", "Doelensteeg"],
    facts: ["Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk.", "Vanaf Hoornaar rijdt u ongeveer 78 kilometer naar Schiphol en 54 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Arkel", "Centrum Hoornaar", "De Schans Hoornaar", "Schelluinen"],
  },
  {
    slug: "kaag",
    name: "Kaag",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.2141,
    lng: 4.5732,
    intro:
      "In Kaag rijden wij zowel korte ritten binnen de gemeente Kaag en Braassem als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Kager (molen)", "Buurtermolen", "Adermolen", "Boeren-Leidse Kaasmuseum"],
    streets: ["Aderpolder", "Balgerij", "Beatrixlaan", "Emmalaan"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Kaag ongeveer 51 kilometer, naar Den Haag 37 kilometer.", "Kaag valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland."],
    pickups: ["Station Sassenheim", "Centrum Kaag", "Aderpolder Kaag", "Rijpwetering"],
  },
  {
    slug: "kinderdijk",
    name: "Kinderdijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8836,
    lng: 4.6418,
    intro:
      "Kinderdijk is onderdeel van de gemeente Molenlanden en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Molentocht (bezienswaardigheid)", "Overwaard Molen No.1", "Nederwaard Molen No.2", "Museummolen Nederwaard (Kinderdijk)"],
    streets: ["Molenstraat", "Beatrixweg", "Brug Blokweersekade", "Christineweg"],
    facts: ["Vanaf Kinderdijk rijdt u ongeveer 86 kilometer naar Schiphol en 34 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Kinderdijk zijn Krimpen aan de Lek, Alblasserdam, Ridderkerk."],
    pickups: ["Centrum Kinderdijk", "Molenstraat Kinderdijk", "Krimpen aan de Lek"],
  },
  {
    slug: "klaaswaal",
    name: "Klaaswaal",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7683,
    lng: 4.4548,
    intro:
      "Klaaswaal is onderdeel van de gemeente Hoeksche Waard en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Het Geitenweitje (dierenpark)", "Windlust (molen)", "De Goede Hoop (molen)", "Landzicht (molen)"],
    streets: ["Kerkstraat", "Rijksstraatweg", "Voorstraat", "Industrieweg"],
    facts: ["Vanaf Klaaswaal rijdt u ongeveer 93 kilometer naar Schiphol en 45 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Klaaswaal zijn Westmaas, Mijnsheerenland, Numansdorp."],
    pickups: ["Centrum Klaaswaal", "Kerkstraat Klaaswaal", "Westmaas"],
  },
  {
    slug: "koudekerk-aan-den-rijn",
    name: "Koudekerk aan den Rijn",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.1421,
    lng: 4.5954,
    intro:
      "Koudekerk aan den Rijn hoort bij de gemeente Alphen aan den Rijn en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Hondsdijkse Molen", "Lagenwaardse Molen", "De Rijnenburger (molen)", "Grosmolen"],
    streets: ["het centrum van Koudekerk aan den Rijn"],
    facts: ["Vanaf Koudekerk aan den Rijn rijdt u ongeveer 36 kilometer naar Schiphol en 37 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Koudekerk aan den Rijn zijn Hazerswoude-Rijndijk, Hoogmade, Leiderdorp."],
    pickups: ["Station Alphen aan den Rijn", "Centrum Koudekerk aan den Rijn", "Hazerswoude-Rijndijk"],
  },
  {
    slug: "krimpen-aan-de-lek",
    name: "Krimpen aan de Lek",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.8999,
    lng: 4.6181,
    intro:
      "In Krimpen aan de Lek rijden wij zowel korte ritten binnen de gemeente Krimpenerwaard als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Kleine Zaag (natuurgebied)", "De Zaag (natuurgebied)", "Pier 2 Overwaard (bezienswaardigheid)", "Bezoekerscentrum Wisboomgemaal (Kinderdijk) (museum)"],
    streets: ["het centrum van Krimpen aan de Lek"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Krimpen aan de Lek ongeveer 25 kilometer, naar Den Haag 59 kilometer.", "Krimpen aan de Lek valt bestuurlijk onder de gemeente Krimpenerwaard in de provincie Zuid-Holland."],
    pickups: ["Station Capelle Centrum", "Centrum Krimpen aan de Lek", "Krimpen aan den IJssel"],
  },
  {
    slug: "krimpen-aan-den-ijssel",
    name: "Krimpen aan den IJssel",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpen aan den IJssel",
    gemeenteUrl: "https://www.krimpenaandenijssel.nl",
    gemeenteSlug: "krimpen-aan-den-ijssel",
    lat: 51.9147,
    lng: 4.6021,
    intro:
      "Wie in Krimpen aan den IJssel vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["De Schelvenaer (molen)", "Streekmuseum Krimpenerwaard", "Winkelcentrum Koperwiek", "De Zaag (natuurgebied)"],
    streets: ["het centrum van Krimpen aan den IJssel"],
    facts: ["Krimpen aan den IJssel vormt een eigen woonplaats binnen de gemeente Krimpen aan den IJssel.", "Vanaf Krimpen aan den IJssel rijdt u ongeveer 59 kilometer naar Schiphol en 40 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Capelle Centrum", "Centrum Krimpen aan den IJssel", "Krimpen aan de Lek"],
  },
  {
    slug: "kwintsheul",
    name: "Kwintsheul",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 52.0138,
    lng: 4.2616,
    intro:
      "In Kwintsheul rijden wij zowel korte ritten binnen de gemeente Westland als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Westlands Museum", "Windlust (molen)", "De Zeven Gaten (natuurgebied)", "Groeneveldse Molen"],
    streets: ["Kerkstraat", "Lange Wateringkade", "'t Hoogje", "Beekforel"],
    facts: ["Buurplaatsen van Kwintsheul zijn Wateringen, Honselersdijk, Poeldijk.", "Naar het centrum van Rotterdam is het vanuit Kwintsheul ongeveer 29 kilometer, naar Den Haag 17 kilometer."],
    pickups: ["Station Rijswijk", "Centrum Kwintsheul", "Kerkstraat Kwintsheul", "Wateringen"],
  },
  {
    slug: "langerak",
    name: "Langerak",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.9303,
    lng: 4.9056,
    intro:
      "Langerak ligt in Zuid-Holland, op ongeveer 80 kilometer van Schiphol en 53 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Willige Langerak (natuurgebied)", "Natuurmuseum en klompenwinkel 'De Wielewaal'", "De Westermolen", "Vesting Nieuwpoort (kasteel)"],
    streets: ["Julianastraat", "Wilhelminastraat", "Bastionhof", "Berenhof"],
    facts: ["Buurplaatsen van Langerak zijn Waal, Nieuwpoort, Goudriaan.", "Naar het centrum van Rotterdam is het vanuit Langerak ongeveer 43 kilometer, naar Den Haag 73 kilometer."],
    pickups: ["Centrum Langerak", "Julianastraat Langerak", "Waal"],
  },
  {
    slug: "leiderdorp",
    name: "Leiderdorp",
    province: "Zuid-Holland",
    gemeente: "Gemeente Leiderdorp",
    gemeenteUrl: "https://www.leiderdorp.nl",
    gemeenteSlug: "leiderdorp",
    lat: 52.1567,
    lng: 4.542,
    intro:
      "Leiderdorp hoort bij de gemeente Leiderdorp en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["WOOON (winkelcentrum)", "Meerburgermolen", "Munnikenmolen", "Doeshofmolen"],
    streets: ["Hoofdstraat", "Provincialeweg 5", "Provincialeweg", "Schoolstraat"],
    facts: ["Leiderdorp valt bestuurlijk onder de gemeente Leiderdorp in de provincie Zuid-Holland.", "Leiderdorp vormt een eigen woonplaats binnen de gemeente Leiderdorp."],
    pickups: ["Station Leiden Lammenschans", "Centrum Leiderdorp", "Hoofdstraat Leiderdorp", "Hoogmade"],
  },
  {
    slug: "leimuiden",
    name: "Leimuiden",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.2187,
    lng: 4.6901,
    intro:
      "In Leimuiden rijden wij zowel korte ritten binnen de gemeente Kaag en Braassem als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Geestmolen", "Museum Oud Alkemade", "Googermolen", "Oudheidkamer (museum)"],
    streets: ["Dorpsstraat", "Provincialeweg", "Kerkweg", "Burgemeester Bakhuizenlaan"],
    facts: ["Leimuiden valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland.", "Binnen de gemeente Kaag en Braassem liggen onder meer Hoogmade, Kaag, Nieuwe Wetering."],
    pickups: ["Station Nieuw Vennep", "Centrum Leimuiden", "Dorpsstraat Leimuiden", "Rijnsaterwoude"],
  },
  {
    slug: "lekkerkerk",
    name: "Lekkerkerk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.9107,
    lng: 4.695,
    intro:
      "Vanuit Lekkerkerk (Zuid-Holland) bent u met de taxi in ongeveer 63 kilometer op Schiphol en in 44 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Lekkerkerk door de tijd (museum)", "Zuidbroekse Molen", "Korte Zand (natuurgebied)", "Natuurrijk (natuurgebied)"],
    streets: ["Voorstraat", "Kerkweg", "Julianastraat", "Wilhelminastraat"],
    facts: ["Buurplaatsen van Lekkerkerk zijn Nieuw-Lekkerland, Ouderkerk aan den IJssel, Berkenwoude.", "Naar het centrum van Rotterdam is het vanuit Lekkerkerk ongeveer 44 kilometer, naar Den Haag 53 kilometer."],
    pickups: ["Centrum Lekkerkerk", "Voorstraat Lekkerkerk", "Nieuw-Lekkerland"],
  },
  {
    slug: "lisse",
    name: "Lisse",
    province: "Zuid-Holland",
    gemeente: "Gemeente Lisse",
    gemeenteUrl: "https://www.lisse.nl",
    gemeenteSlug: "lisse",
    lat: 52.2556,
    lng: 4.5458,
    intro:
      "Lisse is een woonplaats in de gemeente Lisse en ligt op ongeveer 24 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Museum de Zwarte Tulp", "Huis Dever (kasteel)", "Zemelmolen", "De Adriaen (bezienswaardigheid)"],
    streets: ["Molenstraat", "Stationsweg", "Korte Havenstraat", "Nieuwstraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Lisse ongeveer 51 kilometer, naar Den Haag 29 kilometer.", "Lisse valt bestuurlijk onder de gemeente Lisse in de provincie Zuid-Holland."],
    pickups: ["Station Sassenheim", "Centrum Lisse", "Molenstraat Lisse", "Noordwijkerhout"],
  },
  {
    slug: "maasdam",
    name: "Maasdam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7871,
    lng: 4.5483,
    intro:
      "Maasdam hoort bij de gemeente Hoeksche Waard en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Poldersche Molen", "De Hoop (molen)", "Dierenweide SamenZo (dierenpark)", "Middelvliet (natuurgebied)"],
    streets: ["Dorpsstraat", "Julianastraat", "Parallelweg", "Raadhuisstraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Maasdam ongeveer 21 kilometer, naar Den Haag 52 kilometer.", "Maasdam valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland."],
    pickups: ["Centrum Maasdam", "Dorpsstraat Maasdam", "Puttershoek"],
  },
  {
    slug: "maasdijk",
    name: "Maasdijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 51.957,
    lng: 4.2125,
    intro:
      "In Maasdijk rijden wij zowel korte ritten binnen de gemeente Westland als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Dierenweide Maasdijk (dierenpark)", "Tekno Collectables (museum)", "De Oranjeplassen (natuurgebied)", "Staelduinsebos (bezienswaardigheid)"],
    streets: ["Prinses Wilhelminastraat", "Burgemeester Elsenweg", "Lange Kruisweg"],
    facts: ["Maasdijk valt bestuurlijk onder de gemeente Westland in de provincie Zuid-Holland.", "Binnen de gemeente Westland liggen onder meer 's-Gravenzande, De Lier, Honselersdijk."],
    pickups: ["Station Steendijkpolder", "Centrum Maasdijk", "Prinses Wilhelminastraat Maasdijk", "De Lier"],
  },
  {
    slug: "maasland",
    name: "Maasland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Midden-Delfland",
    gemeenteUrl: "https://www.middendelfland.nl",
    gemeenteSlug: "midden-delfland",
    lat: 51.9449,
    lng: 4.2802,
    intro:
      "Vanuit Maasland (Zuid-Holland) bent u met de taxi in ongeveer 60 kilometer op Schiphol en in 19 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["De drie lelies (molen)", "Dijkmolen", "Museum de Schilpen", "De Wippersmolen"],
    streets: ["Kerkstraat", "Stationsstraat", "Kerkweg", "Molenweg"],
    facts: ["Binnen de gemeente Midden-Delfland liggen onder meer Den Hoorn, Schipluiden.", "Vanaf Maasland rijdt u ongeveer 60 kilometer naar Schiphol en 19 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Maassluis Centrum", "Centrum Maasland", "Kerkstraat Maasland", "Maassluis"],
  },
  {
    slug: "melissant",
    name: "Melissant",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7716,
    lng: 4.0622,
    intro:
      "Melissant hoort bij de gemeente Goeree-Overflakkee en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["De Eendracht (molen)", "Zuiderdiepgorzen (natuurgebied)", "Het Hof (landhuis)", "Korenlust (molen)"],
    streets: ["Provincialeweg", "Voorstraat", "Langeweg"],
    facts: ["Melissant valt bestuurlijk onder de gemeente Goeree-Overflakkee in de provincie Zuid-Holland.", "Binnen de gemeente Goeree-Overflakkee liggen onder meer Achthuizen, Den Bommel, Dirksland."],
    pickups: ["Centrum Melissant", "Provincialeweg Melissant", "Dirksland"],
  },
  {
    slug: "middelharnis",
    name: "Middelharnis",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7595,
    lng: 4.1977,
    intro:
      "Middelharnis hoort bij de gemeente Goeree-Overflakkee en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Meneersche Plaat (natuurgebied)", "Lijnbaan Promenade (winkelcentrum)", "Streekmuseum", "De Korenbloem (molen)"],
    streets: ["Molenstraat", "Stationsweg", "Voorstraat", "Molenweg"],
    facts: ["Binnen de gemeente Goeree-Overflakkee liggen onder meer Achthuizen, Den Bommel, Dirksland.", "Vanaf Middelharnis rijdt u ongeveer 106 kilometer naar Schiphol en 58 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Middelharnis", "Molenstraat Middelharnis", "Stad aan 't Haringvliet"],
  },
  {
    slug: "mijnsheerenland",
    name: "Mijnsheerenland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.8035,
    lng: 4.4872,
    intro:
      "Vanuit Mijnsheerenland (Zuid-Holland) bent u met de taxi in ongeveer 82 kilometer op Schiphol en in 18 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["'t Hof van Moerkerken (landhuis)", "De Goede Hoop (molen)", "Windlust (molen)", "Kinderboerderij Binnenmaas (dierenpark)"],
    streets: ["Kerkstraat", "Provincialeweg", "Molenweg", "Julianastraat"],
    facts: ["Mijnsheerenland valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland.", "Binnen de gemeente Hoeksche Waard liggen onder meer 's-Gravendeel, Goudswaard, Heinenoord."],
    pickups: ["Centrum Mijnsheerenland", "Kerkstraat Mijnsheerenland", "Westmaas"],
  },
  {
    slug: "moerkapelle",
    name: "Moerkapelle",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zuidplas",
    gemeenteUrl: "https://www.zuidplas.nl",
    gemeenteSlug: "zuidplas",
    lat: 52.0492,
    lng: 4.5862,
    intro:
      "Voor bewoners en bezoekers van Moerkapelle is de taxi vaak de snelste verbinding met Schiphol (60 km) en Den Haag (28 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Hertogmolen", "Stadsboerderij De Weidemolen (dierenpark)", "Tweemanspolder Molen Nummer 1", "Tweemanspolder Molen Nummer 2"],
    streets: ["Dorpsstraat", "Kerkstraat", "Julianastraat", "Wilhelminastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Moerkapelle ongeveer 26 kilometer, naar Den Haag 28 kilometer.", "Moerkapelle valt bestuurlijk onder de gemeente Zuidplas in de provincie Zuid-Holland."],
    pickups: ["Station Oosterheem", "Centrum Moerkapelle", "Dorpsstraat Moerkapelle", "Waddinxveen"],
  },
  {
    slug: "molenaarsgraaf",
    name: "Molenaarsgraaf",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8675,
    lng: 4.8268,
    intro:
      "Molenaarsgraaf is onderdeel van de gemeente Molenlanden en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Kerkmolen", "De Middelmolen", "Hofwegensemolen", "Tiendwegse Molen"],
    streets: ["Dorpsstraat", "Brederodestraat", "Damseweg", "De Steeg"],
    facts: ["Vanaf Molenaarsgraaf rijdt u ongeveer 85 kilometer naar Schiphol en 41 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Molenaarsgraaf zijn Brandwijk, Ottoland, Giessenburg."],
    pickups: ["Station Hardinxveld-Giessendam", "Centrum Molenaarsgraaf", "Dorpsstraat Molenaarsgraaf", "Brandwijk"],
  },
  {
    slug: "monster",
    name: "Monster",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 52.034,
    lng: 4.1795,
    intro:
      "Monster hoort bij de gemeente Westland en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["De Vier Winden (molen)", "Duinboerderij Willemshoeve (bezienswaardigheid)", "Oorlogsmonument ter nagedachtenis aan de Slag bij Ter Heijde (bezienswaardigheid)", "Muziektent (bezienswaardigheid)"],
    streets: ["Molenstraat", "Stationsweg", "Molenweg", "Havenstraat"],
    facts: ["Monster valt bestuurlijk onder de gemeente Westland in de provincie Zuid-Holland.", "Binnen de gemeente Westland liggen onder meer 's-Gravenzande, De Lier, Honselersdijk."],
    pickups: ["Centrum Monster", "Molenstraat Monster", "Ter Heijde"],
  },
  {
    slug: "mookhoek",
    name: "Mookhoek",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7524,
    lng: 4.596,
    intro:
      "Voor bewoners en bezoekers van Mookhoek is de taxi vaak de snelste verbinding met Schiphol (92 km) en Den Haag (60 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Het Land van Strijen (museum)", "Historische Vereniging 's-Gravendeel (museum)", "Het Vliegend Hert (molen)", "Middelvliet (natuurgebied)"],
    streets: ["Griendstraat", "Kreekstraat", "Mookhoek", "Platte Schenkel"],
    facts: ["Mookhoek valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland.", "Binnen de gemeente Hoeksche Waard liggen onder meer 's-Gravendeel, Goudswaard, Heinenoord."],
    pickups: ["Centrum Mookhoek", "Griendstraat Mookhoek", "'s-Gravendeel"],
  },
  {
    slug: "moordrecht",
    name: "Moordrecht",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zuidplas",
    gemeenteUrl: "https://www.zuidplas.nl",
    gemeenteSlug: "zuidplas",
    lat: 51.9951,
    lng: 4.6595,
    intro:
      "Moordrecht ligt in Zuid-Holland, op ongeveer 62 kilometer van Schiphol en 23 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Dino Experience Park (attractiepark)", "Monument Laagste Punt van Nederland (bezienswaardigheid)", "Kattendijksblokboezem (natuurgebied)", "De Mallemolen"],
    streets: ["Dorpsstraat", "Provincialeweg", "Koningin Julianastraat", "Prinses Wilhelminastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Moordrecht ongeveer 21 kilometer, naar Den Haag 30 kilometer.", "Moordrecht valt bestuurlijk onder de gemeente Zuidplas in de provincie Zuid-Holland."],
    pickups: ["Station Waddinxveen Triangel", "Centrum Moordrecht", "Dorpsstraat Moordrecht", "Cortelande"],
  },
  {
    slug: "nieuw-beijerland",
    name: "Nieuw-Beijerland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7995,
    lng: 4.3671,
    intro:
      "Nieuw-Beijerland ligt in Zuid-Holland, op ongeveer 90 kilometer van Schiphol en 43 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Kinderboerderij Nieuw-Beijerland (dierenpark)", "De Swaen (molen)", "Wolvenpolder (natuurgebied)", "Simonia (molen)"],
    streets: ["Kerkstraat", "Voorstraat", "Marktveld", "Julianastraat"],
    facts: ["Buurplaatsen van Nieuw-Beijerland zijn Piershil, Hekelingen, Oud-Beijerland.", "Naar het centrum van Rotterdam is het vanuit Nieuw-Beijerland ongeveer 27 kilometer, naar Den Haag 58 kilometer."],
    pickups: ["Station Heemraadlaan", "Centrum Nieuw-Beijerland", "Kerkstraat Nieuw-Beijerland", "Piershil"],
  },
  {
    slug: "nieuw-lekkerland",
    name: "Nieuw-Lekkerland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.886,
    lng: 4.6974,
    intro:
      "Nieuw-Lekkerland hoort bij de gemeente Molenlanden en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Lekkerkerk door de tijd (museum)", "Eendenkooi Roodnat (natuurgebied)", "Kortlandse Molen", "Vogeltjesland (natuurgebied)"],
    streets: ["Burgemeester Den Hoedstraat", "Burgemeester Hardonkstraat", "Burgemeester Nieborgstraat", "Veerweg"],
    facts: ["Vanaf Nieuw-Lekkerland rijdt u ongeveer 93 kilometer naar Schiphol en 41 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Nieuw-Lekkerland zijn Lekkerkerk, Oud-Alblas, Alblasserdam."],
    pickups: ["Centrum Nieuw-Lekkerland", "Burgemeester Den Hoedstraat Nieuw-Lekkerland", "Lekkerkerk"],
  },
  {
    slug: "nieuwe-wetering",
    name: "Nieuwe Wetering",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.2074,
    lng: 4.6126,
    intro:
      "Voor bewoners en bezoekers van Nieuwe Wetering is de taxi vaak de snelste verbinding met Schiphol (18 km) en Den Haag (31 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Moppemolen", "Lijkermolen No 1", "Googermolen", "Museum Oud Alkemade"],
    streets: ["Molenweg", "Achterweg", "Bovenweg", "Dwarsweg"],
    facts: ["Buurplaatsen van Nieuwe Wetering zijn Roelofarendsveen, Rijpwetering, Oude Wetering.", "Naar het centrum van Rotterdam is het vanuit Nieuwe Wetering ongeveer 45 kilometer, naar Den Haag 31 kilometer."],
    pickups: ["Centrum Nieuwe Wetering", "Molenweg Nieuwe Wetering", "Roelofarendsveen"],
  },
  {
    slug: "nieuwe-tonge",
    name: "Nieuwe-Tonge",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7078,
    lng: 4.149,
    intro:
      "Nieuwe-Tonge ligt in Zuid-Holland, op ongeveer 111 kilometer van Schiphol en 63 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Faunapark (dierenpark)", "d'Oranjeboom (molen)", "Paardengat (natuurgebied)", "De Dankbaarheid (molen)"],
    streets: ["Kerkstraat", "Voorstraat", "Nieuwstraat", "Koningin Julianastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Nieuwe-Tonge ongeveer 47 kilometer, naar Den Haag 79 kilometer.", "Nieuwe-Tonge valt bestuurlijk onder de gemeente Goeree-Overflakkee in de provincie Zuid-Holland."],
    pickups: ["Centrum Nieuwe-Tonge", "Kerkstraat Nieuwe-Tonge", "Oude-Tonge"],
  },
  {
    slug: "nieuwerbrug-aan-den-rijn",
    name: "Nieuwerbrug aan den Rijn",
    province: "Zuid-Holland",
    gemeente: "Gemeente Bodegraven-Reeuwijk",
    gemeenteUrl: "https://www.bodegraven-reeuwijk.nl",
    gemeenteSlug: "bodegraven-reeuwijk",
    lat: 52.0831,
    lng: 4.8062,
    intro:
      "In Nieuwerbrug aan den Rijn rijden wij zowel korte ritten binnen de gemeente Bodegraven-Reeuwijk als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Weijpoortsche Molen", "Geriefbos Waarder (natuurgebied)", "Ooievaarsbuitenstation Zegveld (dierenpark)", "Geiten (bezienswaardigheid)"],
    streets: ["het centrum van Nieuwerbrug aan den Rijn"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Nieuwerbrug aan den Rijn ongeveer 37 kilometer, naar Den Haag 43 kilometer.", "Nieuwerbrug aan den Rijn valt bestuurlijk onder de gemeente Bodegraven-Reeuwijk in de provincie Zuid-Holland."],
    pickups: ["Station Bodegraven", "Centrum Nieuwerbrug aan den Rijn", "Bodegraven"],
  },
  {
    slug: "nieuwerkerk-aan-den-ijssel",
    name: "Nieuwerkerk aan den IJssel",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zuidplas",
    gemeenteUrl: "https://www.zuidplas.nl",
    gemeenteSlug: "zuidplas",
    lat: 51.9656,
    lng: 4.6183,
    intro:
      "Nieuwerkerk aan den IJssel is een woonplaats in de gemeente Zuidplas en ligt op ongeveer 64 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Dierenweide (dierenpark)", "Winkelcentrum Dorrestein", "Windlust (molen)", "Monument Laagste Punt van Nederland (bezienswaardigheid)"],
    streets: ["het centrum van Nieuwerkerk aan den IJssel"],
    facts: ["Nieuwerkerk aan den IJssel valt bestuurlijk onder de gemeente Zuidplas in de provincie Zuid-Holland.", "Binnen de gemeente Zuidplas liggen onder meer Cortelande, Moerkapelle, Moordrecht."],
    pickups: ["Station Nieuwerkerk aan den IJssel", "Centrum Nieuwerkerk aan den IJssel", "Ouderkerk aan den IJssel"],
  },
  {
    slug: "nieuwkoop",
    name: "Nieuwkoop",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.1461,
    lng: 4.7883,
    intro:
      "Vanuit Nieuwkoop (Zuid-Holland) bent u met de taxi in ongeveer 26 kilometer op Schiphol en in 48 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Dorpsboerderij Nieuwkoop (dierenpark)", "Museum Nieuwkoop", "Zonneveer Noorden - Meije (bezienswaardigheid)", "Lusthof de Haeck (natuurgebied)"],
    streets: ["Dorpsstraat", "Industrieweg", "Het Lange Stuk"],
    facts: ["Binnen de gemeente Nieuwkoop liggen onder meer Nieuwveen, Noorden, Ter Aar.", "Vanaf Nieuwkoop rijdt u ongeveer 26 kilometer naar Schiphol en 52 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Nieuwkoop", "Dorpsstraat Nieuwkoop", "Noorden"],
  },
  {
    slug: "nieuwpoort",
    name: "Nieuwpoort",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.9325,
    lng: 4.8705,
    intro:
      "Wie in Nieuwpoort vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Vesting Nieuwpoort (kasteel)", "Museum Het Stadhuis", "Natuurmuseum en klompenwinkel 'De Wielewaal'", "Willige Langerak (natuurgebied)"],
    streets: ["Schoolstraat", "Achter het Arsenaal", "Bij de Kerk", "Bij de Waterschuur"],
    facts: ["Nieuwpoort valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland.", "Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk."],
    pickups: ["Centrum Nieuwpoort", "Schoolstraat Nieuwpoort", "Groot-Ammers"],
  },
  {
    slug: "nieuwveen",
    name: "Nieuwveen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.205,
    lng: 4.7653,
    intro:
      "In Nieuwveen rijden wij zowel korte ritten binnen de gemeente Nieuwkoop als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Oudheidkamer (museum)", "Veenwater (natuurgebied)", "Tuin van Bram de Groote (natuurgebied)", "Groene Jonker (natuurgebied)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Provincialeweg", "Ringdijk"],
    facts: ["Buurplaatsen van Nieuwveen zijn Vrouwenakker, Zevenhoven, Ter Aar.", "Naar het centrum van Rotterdam is het vanuit Nieuwveen ongeveer 59 kilometer, naar Den Haag 45 kilometer."],
    pickups: ["Centrum Nieuwveen", "Dorpsstraat Nieuwveen", "Vrouwenakker"],
  },
  {
    slug: "noordeloos",
    name: "Noordeloos",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.902,
    lng: 4.9434,
    intro:
      "In Noordeloos rijden wij zowel korte ritten binnen de gemeente Molenlanden als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Boterslootse Molen", "Stijve Molen", "Put van Zessen (natuurgebied)", "Oudendijkse Molen"],
    streets: ["Kerkstraat", "Provincialeweg", "Kerkweg", "Burgemeester Schakelstraat"],
    facts: ["Buurplaatsen van Noordeloos zijn Goudriaan, Hoornaar, Hoogblokland.", "Naar het centrum van Rotterdam is het vanuit Noordeloos ongeveer 41 kilometer, naar Den Haag 70 kilometer."],
    pickups: ["Station Arkel", "Centrum Noordeloos", "Kerkstraat Noordeloos", "Goudriaan"],
  },
  {
    slug: "noorden",
    name: "Noorden",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.169,
    lng: 4.8356,
    intro:
      "Vanuit Noorden (Zuid-Holland) bent u met de taxi in ongeveer 27 kilometer op Schiphol en in 52 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Zonneveer Noorden - Meije (bezienswaardigheid)", "Groene Jonker (natuurgebied)", "Voorn (natuurgebied)", "Snoek (natuurgebied)"],
    streets: ["Anemonenstraat", "Anjerstraat", "Chrysantenstraat", "Dahliastraat"],
    facts: ["Buurplaatsen van Noorden zijn Woerdense Verlaat, Zevenhoven, Nieuwkoop.", "Naar het centrum van Rotterdam is het vanuit Noorden ongeveer 52 kilometer, naar Den Haag 47 kilometer."],
    pickups: ["Centrum Noorden", "Anemonenstraat Noorden", "Woerdense Verlaat"],
  },
  {
    slug: "noordwijk",
    name: "Noordwijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Noordwijk",
    gemeenteUrl: "https://www.noordwijk.nl",
    gemeenteSlug: "noordwijk",
    lat: 52.271,
    lng: 4.4627,
    intro:
      "Voor bewoners en bezoekers van Noordwijk is de taxi vaak de snelste verbinding met Schiphol (29 km) en Den Haag (29 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Museum Van Langeveld", "AtlantikWall Museum", "De Blink (natuurgebied)", "Museum Engelandvaarders"],
    streets: ["Hoofdstraat", "Kerkstraat", "Molenstraat", "Provincialeweg"],
    facts: ["Binnen de gemeente Noordwijk liggen onder meer De Zilk, Noordwijkerhout.", "Vanaf Noordwijk rijdt u ongeveer 29 kilometer naar Schiphol en 46 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Voorhout", "Centrum Noordwijk", "Hoofdstraat Noordwijk", "Noordwijkerhout"],
  },
  {
    slug: "noordwijkerhout",
    name: "Noordwijkerhout",
    province: "Zuid-Holland",
    gemeente: "Gemeente Noordwijk",
    gemeenteUrl: "https://www.noordwijk.nl",
    gemeenteSlug: "noordwijk",
    lat: 52.2633,
    lng: 4.496,
    intro:
      "Wie in Noordwijkerhout vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Museum Van Langeveld", "Hoogeveensemolen", "Lageveensemolen", "Wassergeest (natuurgebied)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Provincialeweg", "Marktplein"],
    facts: ["Noordwijkerhout valt bestuurlijk onder de gemeente Noordwijk in de provincie Zuid-Holland.", "Binnen de gemeente Noordwijk liggen onder meer De Zilk, Noordwijk."],
    pickups: ["Station Voorhout", "Centrum Noordwijkerhout", "Dorpsstraat Noordwijkerhout", "Noordwijk"],
  },
  {
    slug: "nootdorp",
    name: "Nootdorp",
    province: "Zuid-Holland",
    gemeente: "Gemeente Pijnacker-Nootdorp",
    gemeenteUrl: "https://www.pijnacker-nootdorp.nl",
    gemeenteSlug: "pijnacker-nootdorp",
    lat: 52.043,
    lng: 4.4073,
    intro:
      "Nootdorp is onderdeel van de gemeente Pijnacker-Nootdorp en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Windlust (molen)", "Winkelcentrum Parade Nootdorp", "Bieslandse Bos (natuurgebied)", "De Wisselvalligheid (natuurgebied)"],
    streets: ["Dorpsstraat", "Voorstraat", "Markt", "Kerkweg"],
    facts: ["Vanaf Nootdorp rijdt u ongeveer 44 kilometer naar Schiphol en 20 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Nootdorp zijn Pijnacker, Delfgauw, Voorburg."],
    pickups: ["Station Nootdorp", "Centrum Nootdorp", "Dorpsstraat Nootdorp", "Pijnacker"],
  },
  {
    slug: "numansdorp",
    name: "Numansdorp",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7274,
    lng: 4.4548,
    intro:
      "Vanuit Numansdorp (Zuid-Holland) bent u met de taxi in ongeveer 93 kilometer op Schiphol en in 30 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Landzicht (molen)", "Fort Buitensluis (bezienswaardigheid)", "Oude Raadhuis (bezienswaardigheid)", "d'Orangemolen"],
    streets: ["Kerkstraat", "Rijksstraatweg", "Voorstraat", "Havenstraat"],
    facts: ["Vanaf Numansdorp rijdt u ongeveer 93 kilometer naar Schiphol en 46 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Numansdorp zijn Klaaswaal, Strijen, Westmaas."],
    pickups: ["Centrum Numansdorp", "Kerkstraat Numansdorp", "Klaaswaal"],
  },
  {
    slug: "oegstgeest",
    name: "Oegstgeest",
    province: "Zuid-Holland",
    gemeente: "Gemeente Oegstgeest",
    gemeenteUrl: "https://www.oegstgeest.nl",
    gemeenteSlug: "oegstgeest",
    lat: 52.1856,
    lng: 4.4712,
    intro:
      "Wie in Oegstgeest vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Lange Voort (winkelcentrum)", "Oudenhofmolen", "Oud Poelgeest (natuurgebied)", "Hertenkamp (dierenpark)"],
    streets: ["Dorpsstraat", "Lange Voort", "Langenakker"],
    facts: ["Buurplaatsen van Oegstgeest zijn Rijnsburg, Valkenburg, Leiden.", "Naar het centrum van Rotterdam is het vanuit Oegstgeest ongeveer 40 kilometer, naar Den Haag 18 kilometer."],
    pickups: ["Station Leiden Centraal", "Centrum Oegstgeest", "Dorpsstraat Oegstgeest", "Rijnsburg"],
  },
  {
    slug: "ooltgensplaat",
    name: "Ooltgensplaat",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.6757,
    lng: 4.3277,
    intro:
      "Ooltgensplaat ligt in Zuid-Holland, op ongeveer 105 kilometer van Schiphol en 57 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Stichting Dierenweide Ooltgensplaat (dierenpark)", "Groote Gat (natuurgebied)", "Hellegatsplaten (natuurgebied)", "Windlust (molen)"],
    streets: ["Provincialeweg", "Voorstraat", "Nieuwstraat", "Julianastraat"],
    facts: ["Vanaf Ooltgensplaat rijdt u ongeveer 105 kilometer naar Schiphol en 57 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Ooltgensplaat zijn Achthuizen, Den Bommel, Zuid-Beijerland."],
    pickups: ["Centrum Ooltgensplaat", "Provincialeweg Ooltgensplaat", "Achthuizen"],
  },
  {
    slug: "oostvoorne",
    name: "Oostvoorne",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.9175,
    lng: 4.0985,
    intro:
      "In Oostvoorne rijden wij zowel korte ritten binnen de gemeente Voorne aan Zee als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Huis Overburgh (landhuis)", "'t Reigersnest (landhuis)", "Jacobaburcht (kasteel)", "Kinderboerderij Agathahoeve (dierenpark)"],
    streets: ["Stationsweg", "Molenweg", "Hoofdweg", "Burgemeester Bolwidtweg"],
    facts: ["Binnen de gemeente Voorne aan Zee liggen onder meer Brielle, Hellevoetsluis, Oudenhoorn.", "Vanaf Oostvoorne rijdt u ongeveer 81 kilometer naar Schiphol en 34 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Oostvoorne", "Stationsweg Oostvoorne", "Tinte"],
  },
  {
    slug: "ottoland",
    name: "Ottoland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8876,
    lng: 4.8663,
    intro:
      "Voor bewoners en bezoekers van Ottoland is de taxi vaak de snelste verbinding met Schiphol (84 km) en Den Haag (66 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Schaapskooi Ottoland (dierenpark)", "Goudriaanse Molen", "Smoutjes Vlietlanden (natuurgebied)", "Achterlandse Molen"],
    streets: ["Provincialeweg N214", "Provincialeweg", "Burgemeester van Steenbergenstraat", "Burgemeester Visserwerf"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Ottoland ongeveer 37 kilometer, naar Den Haag 66 kilometer.", "Ottoland valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland."],
    pickups: ["Centrum Ottoland", "Provincialeweg N214 Ottoland", "Goudriaan"],
  },
  {
    slug: "oud-ade",
    name: "Oud Ade",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.1862,
    lng: 4.5601,
    intro:
      "Voor bewoners en bezoekers van Oud Ade is de taxi vaak de snelste verbinding met Schiphol (22 km) en Den Haag (30 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Vrouw Vennemolen", "Rode Molen", "Akkerslootmolen", "Blauwe Molen"],
    streets: ["Abdij van Rijnsburglaan", "Achterwetering", "Akkerslootpolder", "Blauwe Polder"],
    facts: ["Oud Ade valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland.", "Binnen de gemeente Kaag en Braassem liggen onder meer Hoogmade, Kaag, Leimuiden."],
    pickups: ["Station Sassenheim", "Centrum Oud Ade", "Abdij van Rijnsburglaan Oud Ade", "Rijpwetering"],
  },
  {
    slug: "oud-alblas",
    name: "Oud-Alblas",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8602,
    lng: 4.7115,
    intro:
      "Wie in Oud-Alblas vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Kooijwijkse Molen", "De Peilmolen", "De Hoop (molen)", "Wingerdse Molen"],
    streets: ["Dorpsstraat", "Kerkstraat", "Provincialeweg N214", "Schoolstraat"],
    facts: ["Oud-Alblas valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland.", "Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk."],
    pickups: ["Station Sliedrecht Baanhoek", "Centrum Oud-Alblas", "Dorpsstraat Oud-Alblas", "Nieuw-Lekkerland"],
  },
  {
    slug: "ouddorp",
    name: "Ouddorp",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7983,
    lng: 3.8889,
    intro:
      "Ouddorp is onderdeel van de gemeente Goeree-Overflakkee en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["De Zwaan (molen)", "De Hoop (molen)", "Museum Ouddorps Raad- en Polderhuis", "De Kouwe Grond (natuurgebied)"],
    streets: ["Stationsweg", "Provincialeweg", "Molenweg", "Oostdijkseweg"],
    facts: ["Vanaf Ouddorp rijdt u ongeveer 101 kilometer naar Schiphol en 54 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Ouddorp zijn Goedereede, Stellendam, Melissant."],
    pickups: ["Centrum Ouddorp", "Stationsweg Ouddorp", "Goedereede"],
  },
  {
    slug: "oude-wetering",
    name: "Oude Wetering",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.2109,
    lng: 4.6423,
    intro:
      "Oude Wetering ligt in Zuid-Holland, op ongeveer 16 kilometer van Schiphol en 41 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Museum Oud Alkemade", "Googermolen", "Geestmolen", "Moppemolen"],
    streets: ["Kerkstraat", "Burgemeester Hoolboomstraat", "Burgemeester Peeklaan", "Burgemeester van Wichenlaan"],
    facts: ["Binnen de gemeente Kaag en Braassem liggen onder meer Hoogmade, Kaag, Leimuiden.", "Vanaf Oude Wetering rijdt u ongeveer 16 kilometer naar Schiphol en 41 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Nieuw Vennep", "Centrum Oude Wetering", "Kerkstraat Oude Wetering", "Nieuwe Wetering"],
  },
  {
    slug: "oude-tonge",
    name: "Oude-Tonge",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.6878,
    lng: 4.2104,
    intro:
      "Voor bewoners en bezoekers van Oude-Tonge is de taxi vaak de snelste verbinding met Schiphol (107 km) en Den Haag (75 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Winkelcentrum Dabbehof", "De Korenbloem (molen)", "Krammerse Slikken (natuurgebied)", "d'Oranjeboom (molen)"],
    streets: ["Kerkstraat", "Molenstraat", "Stationsweg", "Provincialeweg"],
    facts: ["Vanaf Oude-Tonge rijdt u ongeveer 107 kilometer naar Schiphol en 59 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Oude-Tonge zijn Achthuizen, Nieuwe-Tonge, Stad aan 't Haringvliet."],
    pickups: ["Centrum Oude-Tonge", "Kerkstraat Oude-Tonge", "Achthuizen"],
  },
  {
    slug: "oudenhoorn",
    name: "Oudenhoorn",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.8158,
    lng: 4.1843,
    intro:
      "Oudenhoorn ligt in Zuid-Holland, op ongeveer 84 kilometer van Schiphol en 36 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["De Struytse Hoeck (winkelcentrum)", "Historyland (museum)", "Nationaal Brandweer Museum", "Stadsmuseum Hellevoetsluis"],
    streets: ["Molenweg", "Noordse Molenweg", "Julianastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Oudenhoorn ongeveer 36 kilometer, naar Den Haag 51 kilometer.", "Oudenhoorn valt bestuurlijk onder de gemeente Voorne aan Zee in de provincie Zuid-Holland."],
    pickups: ["Centrum Oudenhoorn", "Molenweg Oudenhoorn", "Zuidland"],
  },
  {
    slug: "ouderkerk-aan-den-ijssel",
    name: "Ouderkerk aan den IJssel",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.941,
    lng: 4.655,
    intro:
      "Wie in Ouderkerk aan den IJssel vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Berkenwoudse Boezem (natuurgebied)", "Natuurrijk (natuurgebied)", "Berkenwoudse Driehoek (natuurgebied)", "Polder de Nesse (natuurgebied)"],
    streets: ["het centrum van Ouderkerk aan den IJssel"],
    facts: ["Buurplaatsen van Ouderkerk aan den IJssel zijn Berkenwoude, Nieuwerkerk aan den IJssel, Lekkerkerk.", "Naar het centrum van Rotterdam is het vanuit Ouderkerk aan den IJssel ongeveer 36 kilometer, naar Den Haag 45 kilometer."],
    pickups: ["Station Nieuwerkerk aan den IJssel", "Centrum Ouderkerk aan den IJssel", "Berkenwoude"],
  },
  {
    slug: "papendrecht",
    name: "Papendrecht",
    province: "Zuid-Holland",
    gemeente: "Gemeente Papendrecht",
    gemeenteUrl: "https://www.papendrecht.nl",
    gemeenteSlug: "papendrecht",
    lat: 51.8332,
    lng: 4.7033,
    intro:
      "Papendrecht is een woonplaats in de gemeente Papendrecht en ligt op ongeveer 83 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Wilgendonk (winkelcentrum)", "Kinderboerderij (dierenpark)", "Noordhoekse Weidemolen", "Leefwerf De Biesbosch (museum)"],
    streets: ["Hoofdstraat", "Provincialeweg N214", "Markt van Matena", "Markt"],
    facts: ["Papendrecht valt bestuurlijk onder de gemeente Papendrecht in de provincie Zuid-Holland.", "Papendrecht vormt een eigen woonplaats binnen de gemeente Papendrecht."],
    pickups: ["Station Sliedrecht Baanhoek", "Centrum Papendrecht", "Hoofdstraat Papendrecht", "Oud-Alblas"],
  },
  {
    slug: "pernis-rotterdam",
    name: "Pernis Rotterdam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Rotterdam",
    gemeenteUrl: "https://www.rotterdam.nl",
    gemeenteSlug: "rotterdam",
    lat: 51.884,
    lng: 4.3939,
    intro:
      "In Pernis Rotterdam rijden wij zowel korte ritten binnen de gemeente Rotterdam als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Kinderboerderij De Heij (dierenpark)", "Noletmolen", "Kasteel van Rhoon", "Kinderboerderij De Oedenstee (dierenpark)"],
    streets: ["Pernisser Molenweg", "Burgemeester Beyenstraat", "Burgemeester van Esstraat", "Burgemeester Verduynstraat"],
    facts: ["Vanaf Pernis Rotterdam rijdt u ongeveer 65 kilometer naar Schiphol en 17 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Pernis Rotterdam zijn Rotterdam-Albrandswaard, Poortugaal, Hoogvliet Rotterdam."],
    pickups: ["Station Pernis", "Centrum Pernis Rotterdam", "Pernisser Molenweg Pernis Rotterdam", "Rotterdam-Albrandswaard"],
  },
  {
    slug: "piershil",
    name: "Piershil",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.796,
    lng: 4.3306,
    intro:
      "Wie in Piershil vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Simonia (molen)", "De Swaen (molen)", "Kinderboerderij Nieuw-Beijerland (dierenpark)", "Windlust (molen)"],
    streets: ["Voorstraat", "Koningin Julianastraat", "Koningin Wilhelminastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Piershil ongeveer 30 kilometer, naar Den Haag 61 kilometer.", "Piershil valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland."],
    pickups: ["Station De Akkers", "Centrum Piershil", "Voorstraat Piershil", "Nieuw-Beijerland"],
  },
  {
    slug: "poeldijk",
    name: "Poeldijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 52.0263,
    lng: 4.2234,
    intro:
      "In Poeldijk rijden wij zowel korte ritten binnen de gemeente Westland als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Kiboe (dierenpark)", "Kijkbankje Optiflor (bezienswaardigheid)", "Belevingstuin De Bosroos (bezienswaardigheid)", "Muziektent (bezienswaardigheid)"],
    streets: ["Voorstraat", "Nieuwstraat", "Julianastraat"],
    facts: ["Vanaf Poeldijk rijdt u ongeveer 54 kilometer naar Schiphol en 30 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Poeldijk zijn Honselersdijk, Kwintsheul, Monster."],
    pickups: ["Centrum Poeldijk", "Voorstraat Poeldijk", "Honselersdijk"],
  },
  {
    slug: "poortugaal",
    name: "Poortugaal",
    province: "Zuid-Holland",
    gemeente: "Gemeente Albrandswaard",
    gemeenteUrl: "https://www.albrandswaard.nl",
    gemeenteSlug: "albrandswaard",
    lat: 51.8555,
    lng: 4.4004,
    intro:
      "Poortugaal is een woonplaats in de gemeente Albrandswaard en ligt op ongeveer 71 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Kasteel van Rhoon", "Albrandswaard Avonturen Park (attractiepark)", "Wolvenpolder (natuurgebied)", "Meeuwenpunt (winkelcentrum)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Molenweg", "Schoolstraat"],
    facts: ["Poortugaal valt bestuurlijk onder de gemeente Albrandswaard in de provincie Zuid-Holland.", "Binnen de gemeente Albrandswaard liggen onder meer Rhoon, Rotterdam-Albrandswaard."],
    pickups: ["Station Poortugaal", "Centrum Poortugaal", "Dorpsstraat Poortugaal", "Rotterdam-Albrandswaard"],
  },
  {
    slug: "puttershoek",
    name: "Puttershoek",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.8038,
    lng: 4.5705,
    intro:
      "Wie in Puttershoek vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Korenmolen De Lelie (bezienswaardigheid)", "Dierenweide SamenZo (dierenpark)", "Middelvliet (natuurgebied)", "Het Nieuwe Poldertje (natuurgebied)"],
    streets: ["Schoolstraat", "Julianastraat", "Wilhelminastraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Puttershoek ongeveer 21 kilometer, naar Den Haag 53 kilometer.", "Puttershoek valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland."],
    pickups: ["Station Zwijndrecht", "Centrum Puttershoek", "Schoolstraat Puttershoek", "Maasdam"],
  },
  {
    slug: "reeuwijk",
    name: "Reeuwijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Bodegraven-Reeuwijk",
    gemeenteUrl: "https://www.bodegraven-reeuwijk.nl",
    gemeenteSlug: "bodegraven-reeuwijk",
    lat: 52.046,
    lng: 4.7369,
    intro:
      "Wie in Reeuwijk vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Streekmuseum Oudheidkamer Reeuwijk", "Winkelcentrum Bloemendaal", "Kinderboerderij De Goudse Hofsteden (dierenpark)", "Oukoopse Molen"],
    streets: ["Kerkweg", "Koningin Wilhelminastraat", "Burgemeester Bracklaan", "Burgemeester Lucasselaan"],
    facts: ["Vanaf Reeuwijk rijdt u ongeveer 39 kilometer naar Schiphol en 32 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Reeuwijk zijn Driebruggen, Gouda, Bodegraven."],
    pickups: ["Station Gouda Goverwelle", "Centrum Reeuwijk", "Kerkweg Reeuwijk", "Driebruggen"],
  },
  {
    slug: "rijnsaterwoude",
    name: "Rijnsaterwoude",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.1986,
    lng: 4.6718,
    intro:
      "Wie in Rijnsaterwoude vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Geestmolen", "Museum Oud Alkemade", "Googermolen", "Veendermolen"],
    streets: ["Kerkweg", "Schoolstraat", "De Hemmen", "Eendrachtspad"],
    facts: ["Rijnsaterwoude valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland.", "Binnen de gemeente Kaag en Braassem liggen onder meer Hoogmade, Kaag, Leimuiden."],
    pickups: ["Centrum Rijnsaterwoude", "Kerkweg Rijnsaterwoude", "Oude Wetering"],
  },
  {
    slug: "rijnsburg",
    name: "Rijnsburg",
    province: "Zuid-Holland",
    gemeente: "Gemeente Katwijk",
    gemeenteUrl: "https://www.katwijk.nl",
    gemeenteSlug: "katwijk",
    lat: 52.196,
    lng: 4.4483,
    intro:
      "Rijnsburg is een woonplaats in de gemeente Katwijk en ligt op ongeveer 29 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Het Spinozahuis (museum)", "Kinderboerderij Westerweide (dierenpark)", "Lasergame Katwijk (bezienswaardigheid)", "Korenmolen De Geregtigheid"],
    streets: ["Kerkstraat", "Burgemeester Hermansstraat", "Burgemeester Koomansplein", "Burgemeester Meijboomstraat"],
    facts: ["Buurplaatsen van Rijnsburg zijn Oegstgeest, Valkenburg, Katwijk.", "Naar het centrum van Rotterdam is het vanuit Rijnsburg ongeveer 41 kilometer, naar Den Haag 19 kilometer."],
    pickups: ["Station Leiden Centraal", "Centrum Rijnsburg", "Kerkstraat Rijnsburg", "Oegstgeest"],
  },
  {
    slug: "rijpwetering",
    name: "Rijpwetering",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.1947,
    lng: 4.5906,
    intro:
      "In Rijpwetering rijden wij zowel korte ritten binnen de gemeente Kaag en Braassem als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Lijkermolen No 2", "Lijkermolen No 1", "Waterloosmolen", "Akkerslootmolen"],
    streets: ["Provincialeweg", "Molenweg", "Lange Dwarsweg"],
    facts: ["Rijpwetering valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland.", "Binnen de gemeente Kaag en Braassem liggen onder meer Hoogmade, Kaag, Leimuiden."],
    pickups: ["Station Sassenheim", "Centrum Rijpwetering", "Provincialeweg Rijpwetering", "Nieuwe Wetering"],
  },
  {
    slug: "rockanje",
    name: "Rockanje",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.8821,
    lng: 4.0397,
    intro:
      "Rockanje ligt in Zuid-Holland, op ongeveer 86 kilometer van Schiphol en 38 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Landhuis Strypemonde", "Korenmolen", "Landhuis Olaertsduyn", "Openluchtmuseum De Duinhuisjes"],
    streets: ["Kerkweg", "C Langendoenstraat", "Langendoenhof", "Langeweg"],
    facts: ["Vanaf Rockanje rijdt u ongeveer 86 kilometer naar Schiphol en 38 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Rockanje zijn Oostvoorne, Tinte, Hellevoetsluis."],
    pickups: ["Centrum Rockanje", "Kerkweg Rockanje", "Oostvoorne"],
  },
  {
    slug: "roelofarendsveen",
    name: "Roelofarendsveen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.1927,
    lng: 4.6235,
    intro:
      "In Roelofarendsveen rijden wij zowel korte ritten binnen de gemeente Kaag en Braassem als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Veendermolen", "Museum Oud Alkemade", "Moppemolen", "Lijkermolen No 1"],
    streets: ["Stationsstraat", "Voorstraat", "Kerkweg", "Nieuwstraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Roelofarendsveen ongeveer 46 kilometer, naar Den Haag 32 kilometer.", "Roelofarendsveen valt bestuurlijk onder de gemeente Kaag en Braassem in de provincie Zuid-Holland."],
    pickups: ["Centrum Roelofarendsveen", "Stationsstraat Roelofarendsveen", "Nieuwe Wetering"],
  },
  {
    slug: "rotterdam-albrandswaard",
    name: "Rotterdam-Albrandswaard",
    province: "Zuid-Holland",
    gemeente: "Gemeente Albrandswaard",
    gemeenteUrl: "https://www.albrandswaard.nl",
    gemeenteSlug: "albrandswaard",
    lat: 51.8695,
    lng: 4.4193,
    intro:
      "Voor bewoners en bezoekers van Rotterdam-Albrandswaard is de taxi vaak de snelste verbinding met Schiphol (66 km) en Den Haag (34 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Kasteel van Rhoon", "Kinderboerderij De Heij (dierenpark)", "Albrandswaard Avonturen Park (attractiepark)", "Rotterdam Havenrondvaart (bezienswaardigheid)"],
    streets: ["Abel Tasmanstraat", "Columbusstraat", "Fietspad", "Marco Polostraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Rotterdam-Albrandswaard ongeveer 10 kilometer, naar Den Haag 34 kilometer.", "Rotterdam-Albrandswaard valt bestuurlijk onder de gemeente Albrandswaard in de provincie Zuid-Holland."],
    pickups: ["Station Rhoon", "Centrum Rotterdam-Albrandswaard", "Abel Tasmanstraat Rotterdam-Albrandswaard", "Poortugaal"],
  },
  {
    slug: "rozenburg",
    name: "Rozenburg",
    province: "Zuid-Holland",
    gemeente: "Gemeente Rotterdam",
    gemeenteUrl: "https://www.rotterdam.nl",
    gemeenteSlug: "rotterdam",
    lat: 51.9156,
    lng: 4.2318,
    intro:
      "Wie in Rozenburg vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Kinderboerderij de Beestenboel (dierenpark)", "Koningshoek (winkelcentrum)", "Stoomzeesleper Furie (bezienswaardigheid)", "Nationaal Sleepvaartmuseum"],
    streets: ["Kerkweg", "Molenweg", "Julianastraat", "Wilhelminastraat"],
    facts: ["Vanaf Rozenburg rijdt u ongeveer 71 kilometer naar Schiphol en 23 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Rozenburg zijn Maassluis, Brielle, Maasland."],
    pickups: ["Station Maassluis West", "Centrum Rozenburg", "Kerkweg Rozenburg", "Maassluis"],
  },
  {
    slug: "sassenheim",
    name: "Sassenheim",
    province: "Zuid-Holland",
    gemeente: "Gemeente Teylingen",
    gemeenteUrl: "https://www.teylingen.nl",
    gemeenteSlug: "teylingen",
    lat: 52.2189,
    lng: 4.5175,
    intro:
      "Sassenheim is een woonplaats in de gemeente Teylingen en ligt op ongeveer 22 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Molen De Speelman", "Het Oude Koningshuys (kasteel)", "Kinderboerderij Saksenhoeve (dierenpark)", "Ruïne van Teylingen (bezienswaardigheid)"],
    streets: ["Hoofdstraat", "Molenstraat", "Rijksstraatweg", "Burgemeester Kretpad"],
    facts: ["Buurplaatsen van Sassenheim zijn Voorhout, Warmond, Kaag.", "Naar het centrum van Rotterdam is het vanuit Sassenheim ongeveer 45 kilometer, naar Den Haag 23 kilometer."],
    pickups: ["Station Sassenheim", "Centrum Sassenheim", "Hoofdstraat Sassenheim", "Voorhout"],
  },
  {
    slug: "schelluinen",
    name: "Schelluinen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.85,
    lng: 4.9289,
    intro:
      "Wie in Schelluinen vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Kasteel Schelluinen", "Westmolen", "Oostmolen", "De Avelingen (natuurgebied)"],
    streets: ["Provincialeweg", "Kerkweg", "Langeweg", "Parallelweg"],
    facts: ["Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk.", "Vanaf Schelluinen rijdt u ongeveer 83 kilometer naar Schiphol en 51 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Gorinchem", "Centrum Schelluinen", "Provincialeweg Schelluinen", "Hoornaar"],
  },
  {
    slug: "schipluiden",
    name: "Schipluiden",
    province: "Zuid-Holland",
    gemeente: "Gemeente Midden-Delfland",
    gemeenteUrl: "https://www.middendelfland.nl",
    gemeenteSlug: "midden-delfland",
    lat: 51.9737,
    lng: 4.3253,
    intro:
      "In Schipluiden rijden wij zowel korte ritten binnen de gemeente Midden-Delfland als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["de Kakelenburg (dierenpark)", "Museum Het Tramstation", "De Korpershoek (molen)", "De Beeldenkas (museum)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Rijksstraatweg"],
    facts: ["Schipluiden valt bestuurlijk onder de gemeente Midden-Delfland in de provincie Zuid-Holland.", "Binnen de gemeente Midden-Delfland liggen onder meer Den Hoorn, Maasland."],
    pickups: ["Station Delft Campus", "Centrum Schipluiden", "Dorpsstraat Schipluiden", "Den Hoorn"],
  },
  {
    slug: "schoonhoven",
    name: "Schoonhoven",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.9512,
    lng: 4.8498,
    intro:
      "Schoonhoven hoort bij de gemeente Krimpenerwaard en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Museum Kan / Schellink", "Nederlands Zilvermuseum Schoonhoven", "Bonrepasmolen", "Museum Het Stadhuis"],
    streets: ["Kerkstraat", "Molenstraat", "Stationsstraat", "Kerkweg"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Schoonhoven ongeveer 41 kilometer, naar Den Haag 50 kilometer.", "Schoonhoven valt bestuurlijk onder de gemeente Krimpenerwaard in de provincie Zuid-Holland."],
    pickups: ["Centrum Schoonhoven", "Kerkstraat Schoonhoven", "Nieuwpoort"],
  },
  {
    slug: "simonshaven",
    name: "Simonshaven",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nissewaard",
    gemeenteUrl: "https://www.nissewaard.nl",
    gemeenteSlug: "nissewaard",
    lat: 51.8263,
    lng: 4.2879,
    intro:
      "Vanuit Simonshaven (Zuid-Holland) bent u met de taxi in ongeveer 79 kilometer op Schiphol en in 31 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["De Arend (molen)", "Zendingerfgoedhuis (museum)", "Fluisterboot de IJsvogel (bezienswaardigheid)", "Winkelcentrum Sterrenhof"],
    streets: ["Kerkweg", "Augustapad", "Bernisse Spuidijk", "Beverwijkstraat"],
    facts: ["Vanaf Simonshaven rijdt u ongeveer 79 kilometer naar Schiphol en 32 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Simonshaven zijn Geervliet, Hekelingen, Zuidland."],
    pickups: ["Station De Akkers", "Centrum Simonshaven", "Kerkweg Simonshaven", "Geervliet"],
  },
  {
    slug: "sliedrecht",
    name: "Sliedrecht",
    province: "Zuid-Holland",
    gemeente: "Gemeente Sliedrecht",
    gemeenteUrl: "https://www.sliedrecht.nl",
    gemeenteSlug: "sliedrecht",
    lat: 51.8307,
    lng: 4.7729,
    intro:
      "Sliedrecht ligt in Zuid-Holland, op ongeveer 88 kilometer van Schiphol en 37 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Sliedrechts Museum", "Kinderboerderij 'De Hooizolder' (dierenpark)", "Nationaal Baggermuseum", "Sterrenwacht Mercurius (museum)"],
    streets: ["Kerkstraat", "Stationsweg", "Provincialeweg", "Industrieweg"],
    facts: ["Sliedrecht vormt een eigen woonplaats binnen de gemeente Sliedrecht.", "Vanaf Sliedrecht rijdt u ongeveer 88 kilometer naar Schiphol en 37 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Sliedrecht", "Centrum Sliedrecht", "Kerkstraat Sliedrecht", "Wijngaarden"],
  },
  {
    slug: "sommelsdijk",
    name: "Sommelsdijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.7647,
    lng: 4.1402,
    intro:
      "Wie in Sommelsdijk vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["De Korenbloem (molen)", "Streekmuseum", "Lijnbaan Promenade (winkelcentrum)", "Meneersche Plaat (natuurgebied)"],
    streets: ["Kerkstraat", "Voorstraat", "Marktveld", "Molenweg"],
    facts: ["Sommelsdijk valt bestuurlijk onder de gemeente Goeree-Overflakkee in de provincie Zuid-Holland.", "Binnen de gemeente Goeree-Overflakkee liggen onder meer Achthuizen, Den Bommel, Dirksland."],
    pickups: ["Centrum Sommelsdijk", "Kerkstraat Sommelsdijk", "Dirksland"],
  },
  {
    slug: "stad-aan-t-haringvliet",
    name: "Stad aan 't Haringvliet",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.735,
    lng: 4.2293,
    intro:
      "Stad aan 't Haringvliet is een woonplaats in de gemeente Goeree-Overflakkee en ligt op ongeveer 107 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["De Korenaar (molen)", "De Bommelaer (molen)", "Korendijkse Slikken (natuurgebied)", "d'Oranjeboom (molen)"],
    streets: ["Kerkstraat", "Voorstraat", "Nieuwstraat", "Burgemeester Sterkstraat"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Stad aan 't Haringvliet ongeveer 43 kilometer, naar Den Haag 75 kilometer.", "Stad aan 't Haringvliet valt bestuurlijk onder de gemeente Goeree-Overflakkee in de provincie Zuid-Holland."],
    pickups: ["Centrum Stad aan 't Haringvliet", "Kerkstraat Stad aan 't Haringvliet", "Middelharnis"],
  },
  {
    slug: "stellendam",
    name: "Stellendam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Goeree-Overflakkee",
    gemeenteUrl: "https://www.goeree-overflakkee.nl",
    gemeenteSlug: "goeree-overflakkee",
    lat: 51.8006,
    lng: 4.0346,
    intro:
      "Voor bewoners en bezoekers van Stellendam is de taxi vaak de snelste verbinding met Schiphol (89 km) en Den Haag (57 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Korenlust (molen)", "Zuiderdiepgorzen (natuurgebied)", "Torenmuseum", "Windvang (molen)"],
    streets: ["Provincialeweg N215", "Voorstraat", "Delta-Industrieweg", "Schoolstraat"],
    facts: ["Vanaf Stellendam rijdt u ongeveer 89 kilometer naar Schiphol en 42 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Stellendam zijn Goedereede, Melissant, Dirksland."],
    pickups: ["Centrum Stellendam", "Provincialeweg N215 Stellendam", "Goedereede"],
  },
  {
    slug: "stolwijk",
    name: "Stolwijk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.969,
    lng: 4.7546,
    intro:
      "Vanuit Stolwijk (Zuid-Holland) bent u met de taxi in ongeveer 51 kilometer op Schiphol en in 32 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Commissarissenlanden (natuurgebied)", "Bergvlietse Kade (natuurgebied)", "Boezemmolen nr. 6", "Hooge Boezem achter Haastecht (natuurgebied)"],
    streets: ["Industrieweg", "Schoolstraat", "Torenstraat"],
    facts: ["Buurplaatsen van Stolwijk zijn Bergambacht, Berkenwoude, Haastrecht.", "Naar het centrum van Rotterdam is het vanuit Stolwijk ongeveer 32 kilometer, naar Den Haag 40 kilometer."],
    pickups: ["Station Gouda Goverwelle", "Centrum Stolwijk", "Industrieweg Stolwijk", "Bergambacht"],
  },
  {
    slug: "streefkerk",
    name: "Streefkerk",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.9031,
    lng: 4.7753,
    intro:
      "Streefkerk is een woonplaats in de gemeente Molenlanden en ligt op ongeveer 93 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["De Liefde (molen)", "Buitenlanden Bergambacht (natuurgebied)", "Donkse Laagten (natuurgebied)", "Hertenkamp Bergambacht (dierenpark)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Burgemeester Dekkingstraat", "Burgemeester Viezeelaan"],
    facts: ["Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk.", "Vanaf Streefkerk rijdt u ongeveer 93 kilometer naar Schiphol en 42 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Streefkerk", "Dorpsstraat Streefkerk", "Brandwijk"],
  },
  {
    slug: "strijen",
    name: "Strijen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7496,
    lng: 4.5441,
    intro:
      "Voor bewoners en bezoekers van Strijen is de taxi vaak de snelste verbinding met Schiphol (90 km) en Den Haag (57 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Het Land van Strijen (museum)", "De Hoop (molen)", "Poldersche Molen", "Middelvliet (natuurgebied)"],
    streets: ["Kerkstraat", "Molenstraat", "Molenweg", "Molenwegje"],
    facts: ["Buurplaatsen van Strijen zijn Mookhoek, Maasdam, Strijensas.", "Naar het centrum van Rotterdam is het vanuit Strijen ongeveer 26 kilometer, naar Den Haag 57 kilometer."],
    pickups: ["Centrum Strijen", "Kerkstraat Strijen", "Mookhoek"],
  },
  {
    slug: "strijensas",
    name: "Strijensas",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7132,
    lng: 4.572,
    intro:
      "Strijensas hoort bij de gemeente Hoeksche Waard en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Het Land van Strijen (museum)", "Stadhuis van Klundert (bezienswaardigheid)", "Vestingwerken van Klundert (kasteel)", "Nationaal Vlasserij-Suikermuseum"],
    streets: ["Havenstraat", "Wilhelminastraat", "Adrianus van Vugtstraat", "Buitendijk"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Strijensas ongeveer 36 kilometer, naar Den Haag 65 kilometer.", "Strijensas valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland."],
    pickups: ["Centrum Strijensas", "Havenstraat Strijensas", "Strijen"],
  },
  {
    slug: "ter-aar",
    name: "Ter Aar",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.1777,
    lng: 4.7201,
    intro:
      "Wie in Ter Aar vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Historisch Museum Ter Aar", "Oudheidkamer (museum)", "De Morgenster (molen)", "Boerderij Verhaar (bezienswaardigheid)"],
    streets: ["Molenstraat", "Kerkweg", "Ringdijk", "Lange Schilk"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Ter Aar ongeveer 46 kilometer, naar Den Haag 38 kilometer.", "Ter Aar valt bestuurlijk onder de gemeente Nieuwkoop in de provincie Zuid-Holland."],
    pickups: ["Centrum Ter Aar", "Molenstraat Ter Aar", "Rijnsaterwoude"],
  },
  {
    slug: "ter-heijde",
    name: "Ter Heijde",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 52.03,
    lng: 4.1684,
    intro:
      "Voor bewoners en bezoekers van Ter Heijde is de taxi vaak de snelste verbinding met Schiphol (58 km) en Den Haag (15 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Oorlogsmonument ter nagedachtenis aan de Slag bij Ter Heijde (bezienswaardigheid)", "De Vier Winden (molen)", "Kinderboerderij Vivaldi (dierenpark)", "Duinboerderij Willemshoeve (bezienswaardigheid)"],
    streets: ["Arie Tukstraat", "De Wurft", "Duinhof", "Evertsenstraat"],
    facts: ["Binnen de gemeente Westland liggen onder meer 's-Gravenzande, De Lier, Honselersdijk.", "Vanaf Ter Heijde rijdt u ongeveer 58 kilometer naar Schiphol en 33 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Ter Heijde", "Arie Tukstraat Ter Heijde", "Monster"],
  },
  {
    slug: "tinte",
    name: "Tinte",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.8909,
    lng: 4.1349,
    intro:
      "Tinte hoort bij de gemeente Voorne aan Zee en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Museum in den Halven Maen", "Brigittenpoortje (bezienswaardigheid)", "Korenmolen", "Historisch Museum Den Briel"],
    streets: ["Rijksstraatweg", "Achterweg", "Blindeweg", "Colinslandsedijk"],
    facts: ["Binnen de gemeente Voorne aan Zee liggen onder meer Brielle, Hellevoetsluis, Oostvoorne.", "Vanaf Tinte rijdt u ongeveer 77 kilometer naar Schiphol en 30 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Tinte", "Rijksstraatweg Tinte", "Brielle"],
  },
  {
    slug: "valkenburg",
    name: "Valkenburg",
    province: "Zuid-Holland",
    gemeente: "Gemeente Katwijk",
    gemeenteUrl: "https://www.katwijk.nl",
    gemeenteSlug: "katwijk",
    lat: 52.1699,
    lng: 4.4302,
    intro:
      "Voor bewoners en bezoekers van Valkenburg is de taxi vaak de snelste verbinding met Schiphol (31 km) en Den Haag (16 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Torenmuseum", "Nationaal Smalspoormuseum", "Stoomtrein Katwijk Leiden (bezienswaardigheid)", "Corpus (museum)"],
    streets: ["Hoofdstraat", "Kerkstraat", "Molenstraat", "Stationsweg"],
    facts: ["Binnen de gemeente Katwijk liggen onder meer Katwijk, Rijnsburg.", "Vanaf Valkenburg rijdt u ongeveer 31 kilometer naar Schiphol en 33 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Museum", "Centrum Valkenburg", "Hoofdstraat Valkenburg", "Rijnsburg"],
  },
  {
    slug: "vierpolders",
    name: "Vierpolders",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.8848,
    lng: 4.1812,
    intro:
      "Vierpolders is onderdeel van de gemeente Voorne aan Zee en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Derryvliet (natuurgebied)", "Historisch Museum Den Briel", "Brigittenpoortje (bezienswaardigheid)", "Holle Mare (natuurgebied)"],
    streets: ["Rijksstraatweg", "Kerkweg", "Middelweg"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Vierpolders ongeveer 26 kilometer, naar Den Haag 42 kilometer.", "Vierpolders valt bestuurlijk onder de gemeente Voorne aan Zee in de provincie Zuid-Holland."],
    pickups: ["Station Maassluis West", "Centrum Vierpolders", "Rijksstraatweg Vierpolders", "Zwartewaal"],
  },
  {
    slug: "vlist",
    name: "Vlist",
    province: "Zuid-Holland",
    gemeente: "Gemeente Krimpenerwaard",
    gemeenteUrl: "https://www.krimpenerwaard.nl",
    gemeenteSlug: "krimpenerwaard",
    lat: 51.9773,
    lng: 4.8242,
    intro:
      "In Vlist rijden wij zowel korte ritten binnen de gemeente Krimpenerwaard als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Bachtenaar (molen)", "Schutterskade (natuurgebied)", "Noordzijdse Kade (natuurgebied)", "Bergvlietse Kade (natuurgebied)"],
    streets: ["Beatrixstraat", "Bernhardstraat", "Boerderijhof", "Bonrepas"],
    facts: ["Buurplaatsen van Vlist zijn Schoonhoven, Haastrecht, Stolwijk.", "Naar het centrum van Rotterdam is het vanuit Vlist ongeveer 35 kilometer, naar Den Haag 44 kilometer."],
    pickups: ["Centrum Vlist", "Beatrixstraat Vlist", "Schoonhoven"],
  },
  {
    slug: "voorburg",
    name: "Voorburg",
    province: "Zuid-Holland",
    gemeente: "Gemeente Leidschendam-Voorburg",
    gemeenteUrl: "https://www.lv.nl",
    gemeenteSlug: "leidschendam-voorburg",
    lat: 52.0762,
    lng: 4.3635,
    intro:
      "In Voorburg rijden wij zowel korte ritten binnen de gemeente Leidschendam-Voorburg als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Vlieger (molen)", "Notarishuis (museum)", "Stadskinderboerderij Essesteijn (dierenpark)", "Stadsboerderij De Reigershof (dierenpark)"],
    streets: ["Franse Kerkstraat", "Kerkstraat", "Nieuwe Havenstraat", "Nieuwstraat"],
    facts: ["Voorburg valt bestuurlijk onder de gemeente Leidschendam-Voorburg in de provincie Zuid-Holland.", "Binnen de gemeente Leidschendam-Voorburg liggen onder meer Leidschendam."],
    pickups: ["Station Voorburg 't Loo", "Centrum Voorburg", "Franse Kerkstraat Voorburg", "Nootdorp"],
  },
  {
    slug: "voorhout",
    name: "Voorhout",
    province: "Zuid-Holland",
    gemeente: "Gemeente Teylingen",
    gemeenteUrl: "https://www.teylingen.nl",
    gemeenteSlug: "teylingen",
    lat: 52.2281,
    lng: 4.4938,
    intro:
      "Voorhout hoort bij de gemeente Teylingen en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Kinderboerderij De Klaprooshof (dierenpark)", "Boerhaavehuis (kasteel)", "Molen De Speelman", "Het Oude Koningshuys (kasteel)"],
    streets: ["Kerkweg", "Wilhelminastraat", "Burgemeester Bultenlaan", "Herenstraat"],
    facts: ["Buurplaatsen van Voorhout zijn Sassenheim, Warmond, Noordwijkerhout.", "Naar het centrum van Rotterdam is het vanuit Voorhout ongeveer 45 kilometer, naar Den Haag 23 kilometer."],
    pickups: ["Station Voorhout", "Centrum Voorhout", "Kerkweg Voorhout", "Sassenheim"],
  },
  {
    slug: "voorschoten",
    name: "Voorschoten",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorschoten",
    gemeenteUrl: "https://www.voorschoten.nl",
    gemeenteSlug: "voorschoten",
    lat: 52.1248,
    lng: 4.4386,
    intro:
      "Voorschoten hoort bij de gemeente Voorschoten en heeft geen eigen taxistandplaats: vervoer regelt u hier vooraf. Onze chauffeurs halen u deur-tot-deur op tegen een vaste prijs, ook 's nachts en in het weekend.",
    sights: ["Museum Voorschoten", "Kinderboerderij Voorschoten (dierenpark)", "Hertenkamp (dierenpark)", "Ter Horst (kasteel)"],
    streets: ["Voorstraat", "Industrieweg", "Schoolstraat", "Burgemeester Cannegieterlaan"],
    facts: ["Vanaf Voorschoten rijdt u ongeveer 37 kilometer naar Schiphol en 26 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Voorschoten zijn Leidschendam, Leiden, Valkenburg."],
    pickups: ["Station Voorschoten", "Centrum Voorschoten", "Voorstraat Voorschoten", "Leidschendam"],
  },
  {
    slug: "vrouwenakker",
    name: "Vrouwenakker",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.226,
    lng: 4.789,
    intro:
      "Vrouwenakker is een woonplaats in de gemeente Nieuwkoop en ligt op ongeveer 18 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Tuin van Bram de Groote (natuurgebied)", "Landje van Vermey (natuurgebied)", "Landje van Haak (natuurgebied)", "Bamboe-labyrint Nirwana (bezienswaardigheid)"],
    streets: ["Fietspad", "Nieuveens Jaagpad", "Ruigekade", "Vrouwenakker"],
    facts: ["Vrouwenakker valt bestuurlijk onder de gemeente Nieuwkoop in de provincie Zuid-Holland.", "Binnen de gemeente Nieuwkoop liggen onder meer Nieuwkoop, Nieuwveen, Noorden."],
    pickups: ["Centrum Vrouwenakker", "Fietspad Vrouwenakker", "Nieuwveen"],
  },
  {
    slug: "waal",
    name: "Waal",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.9382,
    lng: 4.8996,
    intro:
      "Waal ligt in Zuid-Holland, op ongeveer 82 kilometer van Schiphol en 55 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Willige Langerak (natuurgebied)", "Natuurmuseum en klompenwinkel 'De Wielewaal'", "Vesting Nieuwpoort (kasteel)", "Museum Het Stadhuis"],
    streets: ["Fietspad", "Lekdijk", "Waal"],
    facts: ["Waal valt bestuurlijk onder de gemeente Molenlanden in de provincie Zuid-Holland.", "Binnen de gemeente Molenlanden liggen onder meer Arkel, Bleskensgraaf ca, Brandwijk."],
    pickups: ["Centrum Waal", "Fietspad Waal", "Langerak"],
  },
  {
    slug: "waarder",
    name: "Waarder",
    province: "Zuid-Holland",
    gemeente: "Gemeente Bodegraven-Reeuwijk",
    gemeenteUrl: "https://www.bodegraven-reeuwijk.nl",
    gemeenteSlug: "bodegraven-reeuwijk",
    lat: 52.056,
    lng: 4.8281,
    intro:
      "Wie in Waarder vroeg naar de luchthaven moet, staat vaak op tijden dat er nog geen bus of trein rijdt. Daarom rijden wij hier 24 uur per dag met een vaste prijs, deur-tot-deur.",
    sights: ["Geriefbos Waarder (natuurgebied)", "De Weijpoortsche Molen", "Oukoopse Molen", "Dierenpark De Wulverhorst"],
    streets: ["Koningin Julianastraat", "Berghoeve", "De Groendijck", "Dorp"],
    facts: ["Buurplaatsen van Waarder zijn Driebruggen, Nieuwerbrug aan den Rijn, Bodegraven.", "Naar het centrum van Rotterdam is het vanuit Waarder ongeveer 36 kilometer, naar Den Haag 41 kilometer."],
    pickups: ["Station Woerden", "Centrum Waarder", "Koningin Julianastraat Waarder", "Driebruggen"],
  },
  {
    slug: "waddinxveen",
    name: "Waddinxveen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Waddinxveen",
    gemeenteUrl: "https://www.waddinxveen.nl",
    gemeenteSlug: "waddinxveen",
    lat: 52.0424,
    lng: 4.6407,
    intro:
      "Vanuit Waddinxveen (Zuid-Holland) bent u met de taxi in ongeveer 46 kilometer op Schiphol en in 25 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Kinderboerderij Dierendal (dierenpark)", "Voorofsche Polder (natuurgebied)", "Kinderboerderij Contactweide (dierenpark)", "GoStores Gouda (winkelcentrum)"],
    streets: ["Kerkstraat", "Stationsstraat", "Provincialeweg N452", "Marktstraat"],
    facts: ["Waddinxveen valt bestuurlijk onder de gemeente Waddinxveen in de provincie Zuid-Holland.", "Waddinxveen vormt een eigen woonplaats binnen de gemeente Waddinxveen."],
    pickups: ["Station Waddinxveen", "Centrum Waddinxveen", "Kerkstraat Waddinxveen", "Moerkapelle"],
  },
  {
    slug: "warmond",
    name: "Warmond",
    province: "Zuid-Holland",
    gemeente: "Gemeente Teylingen",
    gemeenteUrl: "https://www.teylingen.nl",
    gemeenteSlug: "teylingen",
    lat: 52.1995,
    lng: 4.5252,
    intro:
      "Warmond is een woonplaats in de gemeente Teylingen en ligt op ongeveer 29 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Nieuwe Hofmolen", "Laeckermolen", "Zwanburgermolen", "Huys te Warmont (kasteel)"],
    streets: ["Dorpsstraat", "Julianastraat", "Burgemeester Ketelaarstraat", "Burgemeester Nederburghlaan"],
    facts: ["Vanaf Warmond rijdt u ongeveer 29 kilometer naar Schiphol en 41 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Warmond zijn Sassenheim, Oud Ade, Kaag."],
    pickups: ["Station Sassenheim", "Centrum Warmond", "Dorpsstraat Warmond", "Sassenheim"],
  },
  {
    slug: "wassenaar",
    name: "Wassenaar",
    province: "Zuid-Holland",
    gemeente: "Gemeente Wassenaar",
    gemeenteUrl: "https://www.wassenaar.nl",
    gemeenteSlug: "wassenaar",
    lat: 52.1411,
    lng: 4.3671,
    intro:
      "Wassenaar is onderdeel van de gemeente Wassenaar en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["Kijfhoek & Bierlap (natuurgebied)", "Rodelbaan Duinrell (bezienswaardigheid)", "Hertenkamp (natuurgebied)", "Zweefmolen Duinrell (bezienswaardigheid)"],
    streets: ["Kerkstraat", "Molenstraat", "Rijksstraatweg", "Molenweg"],
    facts: ["Vanaf Wassenaar rijdt u ongeveer 36 kilometer naar Schiphol en 29 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Wassenaar zijn Voorschoten, Valkenburg, Katwijk."],
    pickups: ["Station Voorschoten", "Centrum Wassenaar", "Kerkstraat Wassenaar", "Voorschoten"],
  },
  {
    slug: "wateringen",
    name: "Wateringen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Westland",
    gemeenteUrl: "https://www.westland.nl",
    gemeenteSlug: "westland",
    lat: 52.0191,
    lng: 4.2796,
    intro:
      "In Wateringen rijden wij zowel korte ritten binnen de gemeente Westland als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Windlust (molen)", "Op den Dijk (dierenpark)", "De Schaapweimolen", "Woudse Bos (natuurgebied)"],
    streets: ["Julianastraat", "Wilhelminastraat", "Lange Spruit", "Langemeijerpad"],
    facts: ["Wateringen valt bestuurlijk onder de gemeente Westland in de provincie Zuid-Holland.", "Binnen de gemeente Westland liggen onder meer 's-Gravenzande, De Lier, Honselersdijk."],
    pickups: ["Station Rijswijk", "Centrum Wateringen", "Julianastraat Wateringen", "Kwintsheul"],
  },
  {
    slug: "westmaas",
    name: "Westmaas",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7881,
    lng: 4.4657,
    intro:
      "Westmaas ligt in Zuid-Holland, op ongeveer 82 kilometer van Schiphol en 34 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Windlust (molen)", "De Goede Hoop (molen)", "'t Hof van Moerkerken (landhuis)", "Het Geitenweitje (dierenpark)"],
    streets: ["Havenstraat", "Beneden Nieuwstraat", "Nieuwstraat", "Langeweer"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Westmaas ongeveer 18 kilometer, naar Den Haag 50 kilometer.", "Westmaas valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland."],
    pickups: ["Centrum Westmaas", "Havenstraat Westmaas", "Mijnsheerenland"],
  },
  {
    slug: "wijngaarden",
    name: "Wijngaarden",
    province: "Zuid-Holland",
    gemeente: "Gemeente Molenlanden",
    gemeenteUrl: "https://www.molenlanden.nl",
    gemeenteSlug: "molenlanden",
    lat: 51.8506,
    lng: 4.7718,
    intro:
      "In Wijngaarden rijden wij zowel korte ritten binnen de gemeente Molenlanden als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["De Vriendschap (molen)", "Hofwegensemolen", "Wingerdse Molen", "De Middelmolen"],
    streets: ["Dorpsstraat", "Provincialeweg N214", "Provincialeweg N482", "Burgemeester Brouwerstraat"],
    facts: ["Buurplaatsen van Wijngaarden zijn Bleskensgraaf ca, Sliedrecht, Molenaarsgraaf.", "Naar het centrum van Rotterdam is het vanuit Wijngaarden ongeveer 27 kilometer, naar Den Haag 57 kilometer."],
    pickups: ["Station Sliedrecht", "Centrum Wijngaarden", "Dorpsstraat Wijngaarden", "Bleskensgraaf ca"],
  },
  {
    slug: "woerdense-verlaat",
    name: "Woerdense Verlaat",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.1527,
    lng: 4.8612,
    intro:
      "Woerdense Verlaat is een woonplaats in de gemeente Nieuwkoop en ligt op ongeveer 34 kilometer van Schiphol. Wij rijden hier dag en nacht met een vaste prijs die u vooraf ziet, zodat u nooit met een lopende taximeter in de file staat.",
    sights: ["Westveense Molen", "Lusthof de Haeck (natuurgebied)", "De Bovenlanden (natuurgebied)", "Zonneveer Noorden - Meije (bezienswaardigheid)"],
    streets: ["Lange Meentweg", "Amstelkade", "Bosweg", "De Toegang"],
    facts: ["Binnen de gemeente Nieuwkoop liggen onder meer Nieuwkoop, Nieuwveen, Noorden.", "Vanaf Woerdense Verlaat rijdt u ongeveer 34 kilometer naar Schiphol en 52 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Centrum Woerdense Verlaat", "Lange Meentweg Woerdense Verlaat", "Noorden"],
  },
  {
    slug: "woubrugge",
    name: "Woubrugge",
    province: "Zuid-Holland",
    gemeente: "Gemeente Kaag en Braassem",
    gemeenteUrl: "https://www.kaagenbraassem.nl",
    gemeenteSlug: "kaag-en-braassem",
    lat: 52.1732,
    lng: 4.6482,
    intro:
      "Woubrugge ligt in Zuid-Holland, op ongeveer 23 kilometer van Schiphol en 41 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Veendermolen", "Vrouwgeestmolen", "Lagenwaardse Molen", "Noord-Afrikaanse struisvogel, kroonkraanvogel, helmparelhoen (bezienswaardigheid)"],
    streets: ["Kerkstraat", "Kerkweg", "Schoolstraat", "Raadhuisstraat"],
    facts: ["Binnen de gemeente Kaag en Braassem liggen onder meer Hoogmade, Kaag, Leimuiden.", "Vanaf Woubrugge rijdt u ongeveer 23 kilometer naar Schiphol en 41 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Alphen aan den Rijn", "Centrum Woubrugge", "Kerkstraat Woubrugge", "Roelofarendsveen"],
  },
  {
    slug: "zevenhoven",
    name: "Zevenhoven",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nieuwkoop",
    gemeenteUrl: "https://www.nieuwkoop.nl",
    gemeenteSlug: "nieuwkoop",
    lat: 52.1861,
    lng: 4.8012,
    intro:
      "In Zevenhoven rijden wij zowel korte ritten binnen de gemeente Nieuwkoop als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Groene Jonker (natuurgebied)", "Veenwater (natuurgebied)", "Voorn (natuurgebied)", "Oudheidkamer (museum)"],
    streets: ["Dorpsstraat", "Stationsweg", "Molenweg", "Schoolstraat"],
    facts: ["Zevenhoven valt bestuurlijk onder de gemeente Nieuwkoop in de provincie Zuid-Holland.", "Binnen de gemeente Nieuwkoop liggen onder meer Nieuwkoop, Nieuwveen, Noorden."],
    pickups: ["Centrum Zevenhoven", "Dorpsstraat Zevenhoven", "Noorden"],
  },
  {
    slug: "zevenhuizen",
    name: "Zevenhuizen",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zuidplas",
    gemeenteUrl: "https://www.zuidplas.nl",
    gemeenteSlug: "zuidplas",
    lat: 52.0064,
    lng: 4.5774,
    intro:
      "Voor bewoners en bezoekers van Zevenhuizen is de taxi vaak de snelste verbinding met Schiphol (59 km) en Den Haag (27 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Historisch Centrum Ons Verleden (museum)", "Koornmolengat (natuurgebied)", "Eendrachtsmolen", "Bleiswijkse Verlaat (bezienswaardigheid)"],
    streets: ["Dorpsstraat", "Molenweg", "Schoolstraat", "Burgemeester Boerstraat"],
    facts: ["Zevenhuizen valt bestuurlijk onder de gemeente Zuidplas in de provincie Zuid-Holland.", "Binnen de gemeente Zuidplas liggen onder meer Cortelande, Moerkapelle, Moordrecht."],
    pickups: ["Station Nesselande", "Centrum Zevenhuizen", "Dorpsstraat Zevenhuizen", "Bleiswijk"],
  },
  {
    slug: "zoeterwoude",
    name: "Zoeterwoude",
    province: "Zuid-Holland",
    gemeente: "Gemeente Zoeterwoude",
    gemeenteUrl: "https://www.zoeterwoude.nl",
    gemeenteSlug: "zoeterwoude",
    lat: 52.1179,
    lng: 4.5121,
    intro:
      "Zoeterwoude ligt in Zuid-Holland, op ongeveer 31 kilometer van Schiphol en 31 kilometer van Rotterdam The Hague Airport. Wij verzorgen hier luchthavenvervoer, zakelijke ritten en taxibusvervoer met een vaste prijs.",
    sights: ["Weipoortse Vliet (natuurgebied)", "Grote Molen", "Noord Aa (natuurgebied)", "Zelden van Passe (molen)"],
    streets: ["Dorpsstraat", "Industrieweg", "Wilhelminastraat", "Burgemeester Brandtstraat"],
    facts: ["Binnen de gemeente Zoeterwoude liggen onder meer Gelderswoude.", "Vanaf Zoeterwoude rijdt u ongeveer 31 kilometer naar Schiphol en 31 kilometer naar Rotterdam The Hague Airport."],
    pickups: ["Station Leiden Lammenschans", "Centrum Zoeterwoude", "Dorpsstraat Zoeterwoude", "Gelderswoude"],
  },
  {
    slug: "zuid-beijerland",
    name: "Zuid-Beijerland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Hoeksche Waard",
    gemeenteUrl: "https://www.hoekschewaard.nl",
    gemeenteSlug: "hoeksche-waard",
    lat: 51.7474,
    lng: 4.35,
    intro:
      "Voor bewoners en bezoekers van Zuid-Beijerland is de taxi vaak de snelste verbinding met Schiphol (95 km) en Den Haag (62 km). U boekt online, ziet direct de vaste prijs en betaalt vooraf.",
    sights: ["Landzigt (molen)", "Dierenpark Landzicht", "Rien Poortvliet Museum", "Landbouwmuseum Tiengemeten"],
    streets: ["Dorpsstraat", "Lange Eendragtsweg", "Akkerwinde", "Ambachtsheerenlaan"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Zuid-Beijerland ongeveer 31 kilometer, naar Den Haag 62 kilometer.", "Zuid-Beijerland valt bestuurlijk onder de gemeente Hoeksche Waard in de provincie Zuid-Holland."],
    pickups: ["Centrum Zuid-Beijerland", "Dorpsstraat Zuid-Beijerland", "Piershil"],
  },
  {
    slug: "zuidland",
    name: "Zuidland",
    province: "Zuid-Holland",
    gemeente: "Gemeente Nissewaard",
    gemeenteUrl: "https://www.nissewaard.nl",
    gemeenteSlug: "nissewaard",
    lat: 51.808,
    lng: 4.2385,
    intro:
      "Vanuit Zuidland (Zuid-Holland) bent u met de taxi in ongeveer 82 kilometer op Schiphol en in 34 kilometer in Rotterdam. Omdat de prijs vooraf vaststaat, weet u bij het boeken al precies wat de rit kost.",
    sights: ["Zendingerfgoedhuis (museum)", "De Arend (molen)", "Leenheeren Gorzenpolder (natuurgebied)", "Windlust (molen)"],
    streets: ["Dorpsstraat", "Kerkstraat", "Stationsweg", "Kerkweg"],
    facts: ["Naar het centrum van Rotterdam is het vanuit Zuidland ongeveer 34 kilometer, naar Den Haag 50 kilometer.", "Zuidland valt bestuurlijk onder de gemeente Nissewaard in de provincie Zuid-Holland."],
    pickups: ["Centrum Zuidland", "Dorpsstraat Zuidland", "Abbenbroek"],
  },
  {
    slug: "zwammerdam",
    name: "Zwammerdam",
    province: "Zuid-Holland",
    gemeente: "Gemeente Alphen aan den Rijn",
    gemeenteUrl: "https://www.alphenaandenrijn.nl",
    gemeenteSlug: "alphen-aan-den-rijn",
    lat: 52.1056,
    lng: 4.7245,
    intro:
      "Zwammerdam is onderdeel van de gemeente Alphen aan den Rijn en goed bereikbaar via de regionale wegen naar Rotterdam en Den Haag. Uw taxirit kost hier een vast bedrag dat u vóór het boeken ziet.",
    sights: ["De Dikke Molen", "kinderboerderij de Stal (dierenpark)", "Spuipunt Molenviergang (bezienswaardigheid)", "Molen No.3"],
    streets: ["Kerkstraat", "Molenstraat", "Rijksstraatweg", "Burgemeester Hoogenboomstraat"],
    facts: ["Buurplaatsen van Zwammerdam zijn Bodegraven, Aarlanderveen, Boskoop.", "Naar het centrum van Rotterdam is het vanuit Zwammerdam ongeveer 35 kilometer, naar Den Haag 40 kilometer."],
    pickups: ["Station Bodegraven", "Centrum Zwammerdam", "Kerkstraat Zwammerdam", "Bodegraven"],
  },
  {
    slug: "zwartewaal",
    name: "Zwartewaal",
    province: "Zuid-Holland",
    gemeente: "Gemeente Voorne aan Zee",
    gemeenteUrl: "https://www.voorneaanzee.nl",
    gemeenteSlug: "voorne-aan-zee",
    lat: 51.8728,
    lng: 4.2079,
    intro:
      "In Zwartewaal rijden wij zowel korte ritten binnen de gemeente Voorne aan Zee als lange ritten naar de luchthavens. De prijs staat vast vóór het boeken, inclusief bagage en tolwegen.",
    sights: ["Holle Mare (natuurgebied)", "Blanke Waal (natuurgebied)", "Derryvliet (natuurgebied)", "Hillenhoek (natuurgebied)"],
    streets: ["Dorpsstraat", "Schoolstraat", "Abbewerveweg", "Achterweg"],
    facts: ["Vanaf Zwartewaal rijdt u ongeveer 74 kilometer naar Schiphol en 27 kilometer naar Rotterdam The Hague Airport.", "Buurplaatsen van Zwartewaal zijn Heenvliet, Vierpolders, Abbenbroek."],
    pickups: ["Station Maassluis Centrum", "Centrum Zwartewaal", "Dorpsstraat Zwartewaal", "Heenvliet"],
  },
];
